import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, useTheme, Divider } from '@mui/material';
import React, { memo, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import { tokens } from '../../../theme';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteSales, getBomSales, getcategorySales, getproductSales, getSales, getsubcategorySales } from '../../../redux/slice/sales.slice';
import PrintIcon from '@mui/icons-material/Print';
import CircleIcon from '@mui/icons-material/Circle';
import LexendBold from "../../../fonts/Lexend-Bold.ttf";
import LexendRegular from "../../../fonts/Lexend-Regular.ttf";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs; // Use default vfs as a base

const getBase64Image = (img) => {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        image.src = img;
    });
};

const getLexendFonts = async () => {
    const fetchFont = async (fontPath) => {
        const response = await fetch(fontPath);
        const buffer = await response.arrayBuffer();
        return bufferToBase64(buffer);
    };

    const regularFont = await fetchFont(LexendRegular);
    const boldFont = await fetchFont(LexendBold);

    pdfMake.vfs['Lexend-Regular.ttf'] = regularFont;
    pdfMake.vfs['Lexend-Bold.ttf'] = boldFont;

    pdfMake.fonts = {
        Lexend: {
            normal: 'Lexend-Regular.ttf',
            bold: 'Lexend-Bold.ttf',
        },
    };
};

const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};



const SalesDataGrid = memo(({ data, columns }) => {
    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row._id}
            autoHeight
            density="compact"
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
            }}
            initialState={{
                sorting: {
                    sortModel: [
                        { field: "QuotationNo", sort: "desc" }  // 👈 default sorting here
                    ],
                },
            }}
        />
    )
});

const Sales = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const Sales = useSelector(state => state.sales.Sales)
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery('(max-width:500px)');
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [DeleteSales, setDeleteSales] = useState(null);
    const bom = useSelector(state => state.sales.Bom);

    const categories = useSelector(state => state.sales.category);
    const subcategories = useSelector(state => state.sales.subCategory);
    const productData = useSelector(state => state.sales.products);

    useEffect(() => {
        getLexendFonts();
    }, []);

    useEffect(() => {
        dispatch(getcategorySales())
        dispatch(getsubcategorySales())
        dispatch(getproductSales())
        dispatch(getSales())
        dispatch(getBomSales())
    }, [])

    const [logo, setLogo] = useState(null);
    const [stamp, setStamp] = useState(null);

    useEffect(() => {
        const loadImages = async () => {
            const img1 = await getBase64Image("/assets/images/logo/light-logo.png");
            const img2 = await getBase64Image("/assets/images/stamp/stamp.svg");

            setLogo(img1);
            setStamp(img2)
        };

        loadImages();
    }, []);



    const handleAddBOM = () => {
        navigate('/admin/add-sales');
    }

    const handleEdit = (data) => {
        navigate('/admin/add-sales', { state: data })
    }

    const handleDelete = (id) => {
        setDeleteSales(id)
        setDeleteConfirmOpen(true)
    }

    const confirmDelete = () => {
        if (DeleteSales) {
            dispatch(deleteSales(DeleteSales));
            setDeleteConfirmOpen(false);
            setDeleteSales(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteSales(null);
    }

    const formatDate = (dateString) => {
        // log
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [selectedSalesDetails, setSelectedSalesDetails] = useState(null);

    const handleOpen = (bomId) => {
        const bomData = bom.find(item => item._id === bomId);
        setSelectedSalesDetails(bomData);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpen2(false);
    };

    const sortedSales = [...Sales]?.sort((a, b) => {
        return a.QuotationNo.localeCompare(b.QuotationNo);
    });

    const [currentType, setCurrentType] = useState('');
    const [currentId, setCurrentId] = useState('');
    const [fileName, setFileName] = useState('');

    console.log("currentId", currentId);


    const handlePrint = (data, type) => {
        console.log(data);

        setCurrentType(type);
        setCurrentId(data);
        setOpen2(true);
        setFileName(data.customerName + '-' + data.QuotationNo + '-' + data.systemSize + 'kw')

    }

    // //////////////////////////////////////////////////////  ALL PDF DATA //////////////////////////////////////////////////////////////////////////////////

    const terms = [
        {
            title: "PRICE",
            description: "The price quoted in this Proposal is inclusive of design, manufacturing, sourcing, testing, installation, supply & commissioning, as per the bill of materials & ratings submitted by Tvarit along with the final offer."
        },
        {
            title: "PAYMENT TERMS",
            description: "100% of Advance amount of total contract value to be paid by Customer along with the Purchase Order."
        },
        {
            title: "VALIDITY OF OFFER",
            description: "The price quoted by Tvarit along with this Proposal is valid for 30 days and thereafter the same shall be subject to reconfirmation by Tvarit."
        },
        {
            title: "SCOPE OF WORK",
            description: "Any change in scope of work or addition to the bill of materials and / or ratings or any variation, whatsoever, shall be charged extra to Customer."
        },
        {
            title: "WARRANTY",
            description: "The solar power plant carries a FIVE (5) years' warranty against any manufacturing defects, as per existing warranty policy Tvarit Energy. Solar photovoltaic modules carry a performance warranty against excess of 20% degradation in TWENTY-FIVE (25) years as per existing warranty policy of Tvarit Energy. Solar Grid Tie Inverter carry a DC Side 7 Year performance warranty. Tempering, Misuse, addition, dismantling, reinstallation of any of the system components by unauthorized personnel will render warranty null and void."
        },
        {
            title: "TAXES, DUTIES AND RATES",
            description: "Any Variation in taxes & duties as per the statutory requirements or Government notifications will be applicable at the time of supply. Any other taxes / Octroi applicable will be extra to be paid by the customer."
        },
        {
            title: "OPERATION & MAINTENANCE (O&M)",
            description: "Technical Guidance and only Service charges are included in this offer up to 5 years."
        },
        {
            title: "GOVERNING LAW & JURISDICTION",
            description: "All questions concerning the construction, validity and interpretation of this Proposal or any resultant Agreement will be governed by the laws of India, and the courts at Rajkot."
        }
    ];

    const terms1 = [
        {
            title: "Design, Supply, Installation, Testing and Commissioning of Rooftop Solar Power Plant",
            description: ""
        },
        {
            title: "Complete Feasibility Study and Solar Power plant Design & Engineering and Coordination and approval from CEIG, DISCOM.",
            description: ""
        },
        {
            title: "Supply of all equipment of solar PV power plant as per the BOM offered (including their Packaging, Forwarding, Applicable freight charges & transit insurance).",
            description: ""
        },
        {
            title: "On-site Complete Installation & Commissioning including performance testing of the system. System analysis, technical reports, training to client personnel for the O&M and other recommendations if any.",
            description: ""
        },
        {
            title: "Standard Warranty of the Equipment for continuous & un-interrupted working of solar plant.",
            description: ""
        },
        {
            title: "Inverters shall be installed near to PV Area / Along the Shed. Existing Cable trays & cable trench for evacuation at site if any shall be used for Cable Laying and Routing. Tvarit scope is limited up to cable interconnection at LT Panel.",
            description: ""
        }
    ];

    const terms2 = [
        {
            title: "Structural stability report of the roof, Documentation support for CEIG.",
            description: ""
        },
        {
            title: "Net Meter & Net Metering Approval costs from DISCOM (if required). Any changes tometer / network such as CTs / PTs, canopy / box, transformer, metering cubicle,Sanction Load enhancement etc. (if required) will be in customer's scope",
            description: ""
        },
        {
            title: "Supply of all equipment of solar PV power plant as per the BOM offered (including their Packaging, Forwarding, Applicable freight charges & transit insurance)",
            description: ""
        },
        {
            title: "Storage for materials at site, Onsite security for materials & Personnel, Water, and power during execution. ",
            description: ""
        },
        {
            title: "Computer and internet connectivity. ",
            description: ""
        },
        {
            title: "Any official DISCOM charges for their report / supervision / network changes / Bank Guarantee. ",
            description: ""
        },
        {
            title: "Area should easily be accessible for smooth movement of men & material, installation,and maintenance. Provision of Space for Indoor LT Panel, ACDBs and Inverters.",
            description: ""
        }
    ];

    const terms3 = [
        {
            title: "PRICE",
            description: "The price quoted in this Proposal is inclusive of design, manufacturing, sourcing, testing, installation, supply & commissioning, as per the bill of materials & ratings submitted by Tvarit along with the final offer."
        },
        {
            title: "PAYMENT TERMS",
            description: "100% of Advance amount of total contract value to be paid by Customer along with the Purchase Order."
        },
        {
            title: "VALIDITY OF OFFER",
            description: "The price quoted by Tvarit along with this Proposal is valid for 30 days and thereafter the same shall be subject to reconfirmation by Tvarit."
        },
        {
            title: "SCOPE OF WORK",
            description: "Any change in scope of work or addition to the bill of materials and / or ratings or any variation, whatsoever, shall be charged extra to Customer."
        },
        {
            title: "WARRANTY",
            description: "The solar power plant carries a FIVE (5) years' warranty against any manufacturing defects, as per existing warranty policy Tvarit Energy. Solar photovoltaic modules carry a performance warranty against excess of 20% degradation in TWENTY-FIVE (25) years as per existing warranty policy of Tvarit Energy. Solar Grid Tie Inverter carry a DC Side 7 Year performance warranty. Tempering, Misuse, addition, dismantling, reinstallation of any of the system components by unauthorized personnel will render warranty null and void."
        },
        {
            title: "TAXES, DUTIES AND RATES",
            description: "Any Variation in taxes & duties as per the statutory requirements or Government notifications will be applicable at the time of supply. Any other taxes / Octroi applicable will be extra to be paid by the customer."
        },
        {
            title: "OPERATION & MAINTENANCE (O&M)",
            description: "Technical Guidance and only Service charges are included in this offer up to 5 years."
        },
        {
            title: "GOVERNING LAW & JURISDICTION",
            description: "All questions concerning the construction, validity and interpretation of this Proposal or any resultant Agreement will be governed by the laws of India, and the courts at Rajkot."
        }
    ];

    const termsList1 = [
        {
            title: "PRICE:",
            description: "The price quoted in this Proposal is inclusive of design, manufacturing, sourcing, testing, installation, supply & commissioning, as per the bill of materials & ratings submitted by Tvarit along with the final offer. Any change in scope of work or addition to the bill of materials and / or ratings or any variation, whatsoever, shall be charged extra to Customer."
        },
        {
            title: "THE PRICE QUOTED IS CIF-SITE AND IS FIRM",
            description: "The price is exclusive of any taxes, annual maintenance charges or comprehensive maintenance charges or operation & maintenance charges. Any statutory variation in taxes and duties from the date of submission of this proposal including change of rates for Solar PV System and / or its parts / components / equipment's under GST, imposition of Antidumping Duty (ADD) and / or Safeguard Duty (SDD) on imported modules and cells by the Government of India would be to the clients account and shall be payable by the client at actuals."
        },
        {
            title: "PAYMENT TERMS:",
            description: "The payment terms applicable are as follows: A. 20% of Advance amount of total contract value to be paid by Customer along with the Purchase Order B. 40% of total contract value to be paid by customer after getting approvals from nodal agency. C. 30% of total contract value to be paid by customer along with the readiness of material before dispatch. D. 10% of the total contract value within 7 days of installation and commissioning of the plant."
        },
        {
            title: "VALIDITY OF OFFER:",
            description: "He price quoted by Tvarit along with this Proposal is valid for 15 days and thereafter the same shall be subject to reconfirmation by Tvarit."
        },
        {
            title: "TAXES, DUTIES AND RATES:",
            description: "Tvarit at its sole discretion shall have the liberty to raise invoices from any location in India. All the applicable taxes shall be payable by the Customer at actual. Any Variation in taxes & duties as per the statutory requirements or Government notifications will be applicable at the time of supply. Any other taxes / Octroi applicable will be extra to be paid by the customer."
        },
        {
            title: "INCLUSION OF / EXCLUDED ITEMS:",
            description: "Any items not mentioned in the bill of material shall be charged extra and will be to customer's account."
        },
        {
            title: "ACCESS AND PERMITS:",
            description: "The Customer shall ensure the accuracy of all information and / or data to be supplied by the Customerand shall be responsible foracquiring and providing legal andphysical possession of the Site and access thereto, for preparation and maintenance of proper access roads to, and provide the right of way for, the site, and for providing possession of and access to all other areas reasonably required for the proper execution of the contract work, including all requisite rights of way. Customer shall ensure handing over valid road permits (multiple numbers depending on number of truck loads) Tvarit at least five (5) working days prior to dispatch of any supplies."
        },
        {
            title: "INTERRUPTIONS IN WORK:",
            description: "The Customer must not interrupt the works, and/or shall abstain from any act or Comission of which it canreasonably be expected that it may delay the works or make the works more difficult and or expensive for Tvarit Energy."
        },

        // 
        {
            title: "DEEMED EXPORT OF POWER:",
            description: "The Project shall be termed as commissioned when Tvarit evacuates the power generated to Customer grid. However, incase where Tvarit has completed its duties as per the scope of duties mentioned in the Purchase Order, and the Project cannot be commissioned due to any act / inaction on the part of Customer, or due to unavailability of Customer grid, then the Project shall be deemed to be commissioned and Tvarit shall be deemed to have completed its part of obligations under the Purchase Order."
        },
        {
            title: "WARRANTY:",
            description: "The solar power plant carries a FIVE (5) years' warranty against any manufacturing defects, as per existing warranty policy Tvarit Energy. Solar photovoltaic modules carry a performance warranty against excess of 20% degradation in TWENTY-FIVE (25) years as per existing warranty policy of Tvarit Energy. Tempering, Misuse, addition, dismantling, reinstallation of any of the system components by unauthorized personnel will render warranty null and void."
        },
        {
            title: "SECURITY & SAFETY:",
            description: "On delivery of supplies to Customer's site in good condition, Customer shall be responsible for safety & security of the materials till handing over of the same to Tvarit designated personnel for installation. In case there are public disturbances at site which are not exclusively attributable to Tvarit, Customer shall resolve the same at its own risk & cost, for smooth execution of the project by Tvarit. In such case, Customer shall provide safety & security for the Tvarit designated personnel working at site. Any delay in execution or damage of materials due to public disturbances at site shall be attributable to & compensated by Customer."
        },
        {
            title: "CIVIL & STRUCTURAL WORK:",
            description: "Tvarit limits itself to providing structures for its module mounting on RCC roofs and raised structures (raised structures will be provided by Customer). Any changes in design which are attributable to Customer shall be charged extra. Customer shall allow roof penetration for Installation of module mounting clamps on Trapezoidal Sheet profile. The customer shall allow scrapping of the roof for binding civil foundation, hole fastening the structure on the roof or bolting on the shade roofs. However necessary water proofing treatment shall be taken care during the installation. Any additional ground leveling or earthfilling if required as per the site conditions shall be charged extra."
        },
        {
            title: "PERMISSIONS & NOCS:",
            description: "Necessary permissions from various Government authorities and departments for power evacuation shall be taken by the Tvarit. All the applications shall be done in customers name and necessary charges, fees and other expenses shall be paid by the customer which is included in quotation. However, we shall support for submission of plant related details & documents as required for filing applications. Bi-Directional and Energy Meter cost is extra."
        },
        {
            title: "OPERATION & MAINTENANCE (O&M):",
            description: "O&M charges and spares are not included in this offer. However, Tvarit is open to provide AMC Services in a separate contract."
        },
        {
            title: "GOVERNING LAW & JURISDICTION:",
            description: "All questions concerning the construction, validity and interpretation of this Proposal or any resultant Agreement will be governed by the laws of India, and the courts at Rajkot, India shall have exclusive jurisdiction with respect to any dispute that occurs hereof. No remedy described in this Proposal or any resultant Agreement shall in any way limit the parties' remedies available at law, in equity or otherwise in relation to any breach or threatened breach of the terms and condition of the Proposal by any defaulting party, and any party may seek a restrictive injunction from an appropriate court of law to safeguard its interests."
        }
    ]

    const [image1, setImage1] = useState(null);
    const [image3, setImage3] = useState(null);
    const [image4, setImage4] = useState(null);
    const [image5, setImage5] = useState(null);
    const [image6, setImage6] = useState(null);
    const [image7, setImage7] = useState(null);
    const [image8, setImage8] = useState(null);
    const [image9, setImage9] = useState(null);
    const [image10, setImage10] = useState(null);
    const [image11, setImage11] = useState(null);
    const [image12, setImage12] = useState(null);
    const [image13, setImage13] = useState(null);
    const [image999, setImage999] = useState(null);

    async function fetchImageAsBase64(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    useEffect(() => {
        const loadImages = async () => {
            const img1 = await fetchImageAsBase64('../../assets/images/icons/pdfimage1.jpg');
            const img3 = await fetchImageAsBase64('../../assets/images/icons/pdfimage3.jpg');
            const img4 = await fetchImageAsBase64('../../assets/images/icons/pdfimage4.png');
            const img5 = await fetchImageAsBase64('../../assets/images/icons/pdfimage5.jpg');
            const img6 = await fetchImageAsBase64('../../assets/images/icons/pdfimage6.jpg');
            const img7 = await fetchImageAsBase64('../../assets/images/icons/pdfimage7.jpg');
            const img8 = await fetchImageAsBase64('../../assets/images/icons/Home1.jpg');
            const img9 = await fetchImageAsBase64('../../assets/images/icons/location1.jpg');
            const img10 = await fetchImageAsBase64('../../assets/images/icons/solar1.jpg');
            const img11 = await fetchImageAsBase64('../../assets/images/icons/2pdfimg2.jpg');
            const img12 = await fetchImageAsBase64('../../assets/images/icons/3pdfimg11.jpg');
            const img13 = await fetchImageAsBase64('../../assets/images/icons/2pdfimg1.jpg');
            const image999 = await fetchImageAsBase64('../../assets/images/icons/calendar.png');

            setImage1(img1);
            setImage3(img3);
            setImage4(img4);
            setImage5(img5);
            setImage6(img6);
            setImage7(img7);
            setImage8(img8);
            setImage9(img9);
            setImage10(img10);
            setImage11(img11);
            setImage12(img12);
            setImage13(img13);
            setImage999(image999);
        };

        loadImages();
    }, []);



    //  FOR 1ST PDF ............
    const docDefinition = {
        defaultStyle: {
            font: 'Lexend'
        },
        background: function (currentPage) {

            if (currentPage % 2 === 0) {
                return {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 595.28,
                            h: 841.89,
                            color: '#1b325e'
                        }
                    ]
                };
            }
            return {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 595.28,
                        h: 841.89,
                        color: '#fffbf0'
                    }
                ]
            };
        },
        content: [
            {
                // 1st page ........................................................
                image: image1,
                width: 500,
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },

            // 2nd page ........................................................
            {
                text: [
                    { text: 'TVARIT ', color: '#FF8C00', bold: true, fontSize: 24 },
                    { text: 'IS POWERING A CUSTOMER', color: 'white', bold: true, fontSize: 24 }
                ],
                alignment: 'center',
                margin: [80, 40, 80, 20]
            },
            {
                text: [
                    { text: 'Revolution to clean, affordable ', color: 'white', bold: true, fontSize: 18 },
                    { text: 'and locally generated ', color: 'white', bold: true, fontSize: 18 },
                    { text: 'energy.', color: 'green', bold: true, fontSize: 18 }
                ],
                alignment: 'center',
                margin: [100, 0, 100, 10]
            },
            {
                stack: [{
                    canvas: [{
                        type: 'rect',
                        x: 120,
                        y: 0,
                        w: 380,
                        h: 190,
                        r: 6,
                        color: '#ffffff',
                        fillOpacity: 1
                    }],
                    absolutePosition: { x: 0, y: 260 }
                },
                {
                    margin: [90, 25, 0, 15],
                    // table: {
                    //     // widths: ['8%', '42%', '20%'],
                    //     widths: ['8%', '35%', '35%'],
                    //     body: [
                    //         [
                    //             { image: image8, width: 20, margin: [0, 2, 0, 2] },
                    //             { text: 'Customer Name ', style: 'label', color: 'black', margin: [0, 2, 0, 0] },
                    //             { text: `: ${currentId.customerName}`, bold: true, margin: [0, 2, 0, 0] }
                    //         ],
                    //         [
                    //             { image: image9, width: 20, margin: [0, 2, 0, 2] },
                    //             { text: 'Location ', style: 'label', color: 'black', margin: [0, 2, 0, 0] },
                    //             { text: `: ${currentId.location}`, bold: true, margin: [0, 2, 0, 0] }
                    //         ],
                    //         [
                    //             { image: image10, width: 20, margin: [0, 2, 0, 2] },
                    //             { text: 'Proposed Capacity ', style: 'label', color: 'black', margin: [0, 2, 0, 0] },
                    //             { text: `: ${currentId.systemSize}`, bold: true, margin: [0, 2, 0, 0] }
                    //         ]
                    //     ]
                    // },
                    table: {
                        // widths: ['8%', '42%', '20%'],
                        widths: ['10%', '36%', '40%'],
                        body: [
                            [
                                { image: image8, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Customer Name :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.customerName}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image9, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Location :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.location}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image999, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Date :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${formatDate(currentId.Date)}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image10, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Proposed Capacity :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.systemSize}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: (i, node) => {

                            return (i === 0 || i === node.table.body.length) ? 0 : 0.5;
                        },
                        vLineWidth: () => 0,
                        hLineColor: () => '#ddd',
                        paddingLeft: () => 15,
                        paddingRight: () => 15,
                        paddingTop: () => 8,
                        paddingBottom: () => 8,
                        fillColor: function (rowIndex, node, columnIndex) {
                            return null;
                        }
                    }
                }],
                margin: [0, 50, 0, 80]
            },

            {
                image: image3,
                width: 500,
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },

            // 3Rd page ...........................................

            {
                columns: [
                    {
                        image: image4,
                        width: 40,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Bill of Material',
                        style: 'header',
                        margin: [20, 12, 0, 0],
                        bold: true,
                        fontSize: 18,
                        color: 'black',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 20]
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['7%', '27%', '28%', '38%'],
                    body: [
                        [
                            { text: 'No.', style: 'tableHeader' },
                            { text: 'Product / Item', style: 'tableHeader' },
                            { text: 'Make', style: 'tableHeader' },
                            { text: 'Technical Specification', style: 'tableHeader' }
                        ],
                        ...(currentId?.SalesDetails || []).map((row, index) => [
                            { text: index + 1, style: 'tableBody', alignment: 'center' },
                            { text: row.salesproduct || '', style: 'tableBody', },
                            { text: row.salesmake || '', style: 'tableBody', },
                            { text: row.salesspecifiaction || '', style: 'tableBody', }
                        ])
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 2 : 1),
                    vLineWidth: () => 1,
                    vLineColor: () => '#ddd',
                    hLineColor: (i) => (i === 0 ? '#4CAF50' : '#ddd'),
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: () => 8,
                    paddingBottom: () => 8,
                }
            },
            {
                image: image5,
                width: 500,
                alignment: 'center',
                margin: [0, 20, 0, 0]
            },
            { text: '', pageBreak: 'after' },


            // 4th page ...............................
            {
                columns: [
                    {
                        image: image4,
                        width: 40,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Commercial Offer',
                        style: 'header',
                        margin: [20, 0, 0, 2],
                        bold: true,
                        fontSize: 22,
                        color: 'white',
                        alignment: 'left'
                    }
                ],
                margin: [0, 20, 0, 0]
            },
            {
                text: 'Price for Design, Supply, Installation, Testing & Commissioning',
                style: 'subheader',
                margin: [61, 0, 205, 50],
                color: 'white',
                fontSize: 12,
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['7%', '65%', '28%'],
                    body: [
                        [
                            { text: 'No.', style: 'tableHeader', alignment: "center" },
                            { text: 'Product / Item', style: 'tableHeader', alignment: 'center' },
                            { text: 'Amount', style: 'tableHeader', alignment: 'center' }
                        ],
                        [
                            { text: '1.', style: 'tableBody', alignment: 'center' },
                            // { text: `Supply, Installation, Testing & Commissioning of ${currentId.systemSize} kWp Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.`, style: 'tableBody' },
                            {
                                text: [
                                    'Supply, Installation, Testing & Commissioning of ',
                                    { text: `${currentId.systemSize} kWp`, color: '#009A47' },
                                    ' Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.'
                                ],
                                style: 'tableBody'
                            },
                            { text: 'Rs. ' + currentId.Amount1 + ' /-', style: 'tableBody', alignment: 'center' }
                        ],
                        [
                            { text: '2.', style: 'tableBody', alignment: 'center' },
                            { text: 'Net Meter, Stamp and MCB Charge', style: 'tableBody' },
                            { text: 'Rs. ' + currentId.Amount2 + ' /-', style: 'tableBody', alignment: 'center' }
                        ],
                        [
                            { text: '3.', style: 'tableBody', alignment: 'center' },
                            { text: 'Super Structure and Extra Cable Charge', style: 'tableBody' },
                            { text: 'Rs. ' + currentId.Amount3 + ' /-', style: 'tableBody', alignment: 'center' }
                        ],
                        [
                            { text: '4.', style: 'tableBody', alignment: 'center' },
                            { text: 'Total Amount', style: 'tableBody' },
                            { text: 'Rs. ' + currentId.Amount4 + ' /-', style: 'tableBody', alignment: 'center' }
                        ],
                        [
                            { text: '5.', style: 'tableBody', alignment: 'center' },
                            { text: 'Government Subsidy Benefit', style: 'tableBody' },
                            { text: 'Rs. ' + currentId.Amount5 + ' /-', style: 'tableBody', alignment: 'center' }
                        ],
                        [
                            { text: '6.', style: 'tableBody', alignment: 'center' },
                            { text: 'Price After Subsidy', style: 'tableBody' },
                            { text: 'Rs. ' + currentId.Amount6 + ' /-', style: 'tableBody', alignment: 'center' }
                        ],
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 2 : 1),
                    vLineWidth: () => 1,
                    hLineColor: (i) => (i === 0 ? '#4CAF50' : '#ddd'),
                    vLineColor: () => '#ddd',
                    // fillColor: (rowIndex) => (rowIndex === 0 ? '#4CAF50' : null),
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: (i) => (i === 0 ? 8 : 20),
                    paddingBottom: (i) => (i === 0 ? 8 : 20),
                    fillColor: () => '#ffffff',
                }
            },
            {
                text: 'Note:',
                style: 'noteHeader',
                margin: [0, 50, 0, 10],
                color: '#FF8C00'
            },
            {
                ul: currentId?.termsData?.map((term, index) => ({
                    text: [{ text: term.name }, { text: ` :- ${term.description}` }],
                })),
                style: 'noteBody'

            },
            { text: '', pageBreak: 'after' },
            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'General Terms & Conditions',
                        style: 'header',
                        margin: [30, 10, 0, 10],
                        bold: true,
                        fontSize: 22,
                        color: '#000',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 8]
            },
            {
                ul: terms.map(term => ({
                    stack: [
                        {
                            text: [
                                { text: `${term.title} :- `, bold: true },
                                // { text: '\n' }, // Line break after title
                                { text: term.description } // Description on new line
                            ],
                            margin: [0, 0, 0, 10],
                            fontSize: 9,
                            alignment: 'justify'
                        },
                        {
                            canvas: [
                                {
                                    type: 'line',
                                    x1: 0,
                                    y1: 0,
                                    x2: 515, // Width of the line - adjust as needed
                                    y2: 0,
                                    lineWidth: 1,
                                    lineColor: '#ddd' // Border color - adjust as needed
                                }
                            ],
                            margin: [0, 0, 0, 10] // Margin after border
                        }
                    ]
                })),
                margin: [0, 10, 0, 10],
                style: 'termsList',
                markerColor: '#009A47',
                marker: {
                    type: 'circle',
                    size: 50, // This controls the size of the bullet point
                    color: '#009A47'
                },
                bulletMargin: 30,
                indent: 60
                // type: {
                //     circle: {
                //         width: 50,  // Increased to 50px
                //         height: 50, // Increased to 50px
                //         fillColor: '#009A47',
                //         borderRadius: 25 // Half of width/height (50/2) for perfect circle
                //     }
                // },
                // bulletMargin: 30, // Increased for better spacing with larger bullets
                // indent: 60
            },
            {
                image: image6,
                width: 500,
                alignment: 'center'
            },
            {
                image: image7,
                width: 500,
                alignment: 'center'
            },

        ],

        styles: {
            header: {
                fontSize: 22,
                bold: true,
                alignment: 'center'
            },
            subheader: {
                fontSize: 16,
                bold: true
            },
            body: {
                fontSize: 10
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'white',
                fillColor: '#009A47'
            },
            tableBody: {
                fontSize: 9
            },
            noteHeader: {
                fontSize: 12,
                bold: true,
                color: '#FFA500'
            },
            noteBody: {
                fontSize: 10,
                color: '#FF8C00'
            }
        }
    };


    //  FOR 2ND PDF ............
    const docDefinition2 = {
        defaultStyle: {
            font: 'Lexend'
        },
        background: function (currentPage) {

            if (currentPage === 2 || currentPage === 7 || currentPage === 10) {
                return {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 595.28,
                            h: 841.89,
                            color: '#1b325e'
                        }
                    ]
                };
            }
            return {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 595.28,
                        h: 841.89,
                        color: '#fffbf0'
                    }
                ]
            };
        },
        content: [
            // 1st page ........................................................
            {
                image: image13,
                width: 500,
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },
            // 2nd page ........................................................
            {
                text: [
                    { text: 'TVARIT ', color: '#FF8C00', bold: true, fontSize: 24 },
                    { text: 'IS POWERING A CUSTOMER', color: 'white', bold: true, fontSize: 24 }
                ],
                alignment: 'center',
                margin: [80, 40, 80, 20]
            },
            {
                text: [
                    { text: 'Revolution to clean, affordable ', color: 'white', bold: true, fontSize: 18 },
                    { text: 'and locally generated ', color: 'white', bold: true, fontSize: 18 },
                    { text: 'energy.', color: 'green', bold: true, fontSize: 18 }
                ],
                alignment: 'center',
                margin: [100, 0, 100, 10]
            },
            {
                stack: [{
                    canvas: [{
                        type: 'rect',
                        x: 120,
                        y: 0,
                        w: 380,
                        h: 190,
                        r: 6,
                        color: '#ffffff',
                        fillOpacity: 1
                    }],
                    absolutePosition: { x: 0, y: 260 }
                },
                {
                    margin: [90, 25, 0, 15],
                    table: {
                        // widths: ['8%', '42%', '20%'],
                        widths: ['10%', '36%', '40%'],
                        body: [
                            [
                                { image: image8, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Customer Name :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.customerName}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image9, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Location :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.location}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image999, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Date :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${formatDate(currentId.Date)}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image10, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Proposed Capacity :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.systemSize}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: (i, node) => {

                            return (i === 0 || i === node.table.body.length) ? 0 : 0.5;
                        },
                        vLineWidth: () => 0,
                        hLineColor: () => '#ddd',
                        paddingLeft: () => 15,
                        paddingRight: () => 15,
                        paddingTop: () => 8,
                        paddingBottom: () => 8,
                        fillColor: function (rowIndex, node, columnIndex) {
                            return null;
                        }
                    }
                }],
                margin: [0, 50, 0, 80]
            },
            {
                image: image3,
                width: 500,
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },

            // 3rd page ........................................................
            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Confidentiality & General Conditions Notice',
                        style: 'header',
                        margin: [20, 10, 230, 0],
                        bold: true,
                        fontSize: 16,
                        color: 'black',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 0]
            },
            {
                text: 'This commercial proposal for installation of solar rooftop power system (the "proposal") is submitted with the intent of executing a definitive and legally binding agreement (the "agreement") following an award of business to Tvarit Energy LLP. ("Tvarit").',
                margin: [20, 40, 20, 10],
                fontSize: 9,
                alignment: 'justify'
            },
            {
                text: 'The Proposal itself is a legally binding offer to contract and in the event of an award to Tvarit Energy, it shall execute an Agreement that will be the complete agreement between the parties; however, where the parties do not execute any such Agreement, then the terms and conditions mentioned in this Proposal shall govern any purchase order(s) issued by the Customer in reference to the installation of rooftop solar power system.',
                margin: [20, 10, 20, 10],
                fontSize: 9,
                alignment: 'justify'
            },
            {
                text: 'This Proposal constitutes confidential and proprietary information of Tvarit and requires that customer treat the information contained in this proposal as confidential. Customer may use the information contained in this proposal solely for the purposes of evaluating this proposal & executing the agreement with Tvarit. This proposal & all supporting documentation and manuals provided to customer in connection with this proposal shall remain the property of Tvarit & must be returned immediately upon request.',
                margin: [20, 10, 20, 10],
                fontSize: 9,
                alignment: 'justify'
            },
            {
                text: 'This proposal is based upon the set of requirements provided by customer to Tvarit, and certain reasonable assumptions taken by Tvarit and that may be set forth by owner. If customer alters the requirements or if any assumption stated here in are false or inaccurate, then this proposal, including pricing, may change. Implementation of any services detailed in this proposal is subject to applicable legal and regulatory norms and requirements in force as on the date when services are to be implemented and such implementation may vary to cater to the requirements of such applicable legal and regulatory norms and requirements.',
                margin: [20, 10, 20, 10],
                fontSize: 9,
                alignment: 'justify'
            },
            {
                image: image11,
                width: 500,
                alignment: 'center',
                margin: [0, 20, 0, 20]
            },
            { text: '', pageBreak: 'after' },

            // 4th page ........................................................
            {
                columns: [
                    {
                        image: image4,
                        width: 40,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Scope Of Work',
                        style: 'header',
                        margin: [20, 12, 0, 0],
                        bold: true,
                        fontSize: 18,
                        color: 'black',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 0]
            },
            {
                text: ' Our Scope ',
                style: 'header',
                margin: [0, 25, 0, 0],
                bold: true,
                fontSize: 16,
                color: 'black',
                alignment: 'left'
            },
            {
                ul: terms1.map(term => ({
                    columns: [
                        {
                            text: `${term.title}`,
                            margin: [0, 0, 0, 20],
                            fontSize: 9,
                            alignment: 'justify'
                        }
                    ],
                    margin: [0, 0, 0, 10]
                })),
                margin: [0, 10, 0, 10],
                style: 'termsList'
            },
            {
                image: image6,
                width: 500,
                alignment: 'center',
                margin: [0, 40, 0, 20]
            },
            { text: '', pageBreak: 'after' },

            // 5th page ........................................................
            {
                columns: [
                    {
                        image: image4,
                        width: 40,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Scope Of Work',
                        style: 'header',
                        margin: [20, 12, 0, 0],
                        bold: true,
                        fontSize: 18,
                        color: 'black',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 0]
            },
            {
                text: 'Customer`s Scope',
                style: 'header',
                margin: [0, 25, 0, 0],
                bold: true,
                fontSize: 16,
                color: 'black',
                alignment: 'left'
            },
            {
                ul: terms2.map(term => ({
                    columns: [
                        {
                            text: `${term.title}`,
                            margin: [0, 0, 0, 20],
                            fontSize: 9,
                            alignment: 'justify'
                        }
                    ],
                    margin: [0, 0, 0, 10]
                })),
                margin: [0, 10, 0, 10],
                style: 'termsList'
            },
            {
                image: image6,
                width: 500,
                alignment: 'center',
                margin: [0, 40, 0, 20]
            },
            { text: '', pageBreak: 'after' },

            // 6th page ........................................................


            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Bill of Material',
                        style: 'header',
                        margin: [20, 12, 0, 0],
                        bold: true,
                        fontSize: 18,
                        color: 'black',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 20]
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['7%', '27%', '28%', '38%'],
                    body: [
                        [
                            { text: 'No.', style: 'tableHeader', color: 'white', fontSize: 10 },
                            { text: 'Product / Item', style: 'tableHeader', color: 'white', fontSize: 10 },
                            { text: 'Make', style: 'tableHeader', color: 'white', fontSize: 10 },
                            { text: 'Technical Specification', style: 'tableHeader', color: 'white', fontSize: 10 }
                        ],
                        ...(currentId?.SalesDetails || []).map((row, index) => [
                            { text: index + 1, style: 'tableBody', fontSize: 9 },
                            { text: row.salesproduct || '', style: 'tableBody', fontSize: 9 },
                            { text: row.salesmake || '', style: 'tableBody', fontSize: 9 },
                            { text: row.salesspecifiaction || '', style: 'tableBody', fontSize: 9 }
                        ])
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 2 : 1),
                    vLineWidth: () => 1,
                    vLineColor: "#ddd",
                    hLineColor: (i) => (i === 0 ? '#00A651' : '#ddd'),
                    fillColor: (rowIndex) => (rowIndex === 0 ? '#00A651' : null),
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: (i) => (i === 0 ? 8 : 6),
                    paddingBottom: (i) => (i === 0 ? 8 : 6),
                }
            },
            { text: '', pageBreak: 'after' },

            // 7th page ........................................................
            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Commercial Offer',
                        style: 'header',
                        margin: [10, 0, 0, 2],
                        bold: true,
                        fontSize: 22,
                        color: 'white',
                        alignment: 'left'
                    }
                ],
                margin: [0, 20, 0, 0]
            },
            {
                text: 'Price for Design, Supply, Installation, Testing & Commissioning',
                style: 'subheader',
                margin: [61, 0, 205, 50],
                color: 'white',
                fontSize: 12,
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['7%', '65%', '28%'],
                    body: [
                        [
                            { text: 'No.', style: 'tableHeader', color: 'white', alignment: "center", fontSize: 10 },
                            { text: 'Product / Item', style: 'tableHeader', color: 'white', alignment: "center", fontSize: 10 },
                            { text: 'Amount', style: 'tableHeader', color: 'white', alignment: "center", fontSize: 10 }
                        ],
                        [
                            { text: '1.', style: 'tableBody', alignment: "center", fontSize: 9 },
                            // { text: `Supply, Installation, Testing & Commissioning of ${currentId.systemSize} kWp Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.`, style: 'tableBody', fontSize: 11 },
                            {
                                text: [
                                    'Supply, Installation, Testing & Commissioning of ',
                                    { text: `${currentId.systemSize} kWp`, color: '#009A47', fontSize: 9 },
                                    ' Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.'
                                ],
                                style: 'tableBody', fontSize: 9
                            },
                            { text: `Rs. ${currentId.Amount1}/-`, style: 'tableBody', alignment: "center", fontSize: 9 }
                        ],
                        [
                            { text: '2.', style: 'tableBody', alignment: "center", fontSize: 9 },
                            { text: `${new Date(currentId.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}`, style: 'tableBody', fontSize: 9 },
                            { text: ` ${currentId.Amount2}/-`, style: 'tableBody', alignment: "center", fontSize: 9 }
                        ],
                        [
                            { text: '3.', style: 'tableBody', alignment: "center" },
                            { text: 'Total Amount', style: 'tableBody', fontSize: 9 },
                            { text: `Rs. ${currentId.Amount3}/-`, style: 'tableBody', alignment: "center", fontSize: 9 }
                        ],
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 2 : 1),
                    vLineWidth: () => 1,
                    vLineColor: () => '#ddd',
                    hLineColor: (i) => (i === 0 ? '#00A651' : '#ddd'),
                    fillColor: (rowIndex) => (rowIndex === 0 ? '#00A651' : '#ffffff'),
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: (i) => (i === 0 ? 8 : 12),
                    paddingBottom: (i) => (i === 0 ? 8 : 12),

                }
            },
            {
                text: 'Note:',
                style: 'noteHeader',
                color: '#FF8C00',
                margin: [0, 50, 0, 10]
            },
            {
                ul: currentId?.termsData?.map((term, index) => ({
                    text: [{ text: term.name }, { text: ` :- ${term.description}` }],
                })),
                style: 'noteBody',
                color: '#FF8C00'
            },
            { text: '', pageBreak: 'after' },

            // 8th page ........................................................
            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'General Terms & Conditions',
                        style: 'header',
                        margin: [30, 10, 0, 10],
                        bold: true,
                        fontSize: 22,
                        color: '#000',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 10]
            },
            // {
            //     ul: termsList1.map(term => ({
            //         text: [{ text: `${term.title}`, bold: true }, ` :- ${term.description}`],
            //         margin: [0, 0, 0, 22],
            //         fontSize: 11,
            //         alignment: 'justify'

            //     })),
            //     margin: [0, 10, 0, 10],
            //     style: 'termsList'
            // },

            {
                ul: termsList1.map(term => ({
                    stack: [
                        {
                            text: [
                                { text: `${term.title} :- `, bold: true },
                                // { text: '\n' }, // Line break after title
                                { text: term.description } // Description on new line
                            ],
                            margin: [0, 0, 0, 14],
                            fontSize: 9,
                            alignment: 'justify'
                        },
                        {
                            canvas: [
                                {
                                    type: 'line',
                                    x1: 0,
                                    y1: 0,
                                    x2: 515, // Width of the line - adjust as needed
                                    y2: 0,
                                    lineWidth: 1,
                                    lineColor: '#ddd' // Border color - adjust as needed
                                }
                            ],
                            margin: [0, 0, 0, 10] // Margin after border
                        }
                    ]
                })),
                margin: [0, 10, 0, 10],
                style: 'termsList',
                markerColor: '#009A47',
                type: {
                    circle: {
                        width: 50,
                        height: 50,
                        fillColor: '#009A47',
                        borderRadius: 25
                    }
                }
            },

            // 9th page ........................................................

            { text: '', pageBreak: 'after' },
            {
                image: image7,
                width: 500,
                alignment: 'center'
            },
        ],
        styles: {
            header: {
                fontSize: 22,
                bold: true,
                alignment: 'center'
            },
            subheader: {
                fontSize: 16,
                bold: true
            },
            body: {
                fontSize: 10
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'white',
                fillColor: '#009A47'
            },
            tableBody: {
                fontSize: 9
            },
            noteHeader: {
                fontSize: 12,
                bold: true,
                color: '#FFA500'
            },
            noteBody: {
                fontSize: 10,
                color: '#FF8C00'
            }
        }
    };


    //  FOR 3RD PDF ............
    const docDefinition3 = {
        defaultStyle: {
            font: 'Lexend'
        },
        background: function (currentPage) {

            if (currentPage % 2 === 0) {
                return {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: 595.28,
                            h: 841.89,
                            color: '#1b325e'
                        }
                    ]
                };
            }
            return {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 595.28,
                        h: 841.89,
                        color: '#fffbf0'
                    }
                ]
            };
        },
        content: [

            // 1st page ........................................................

            {
                image: image12,
                width: 500,
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },

            // 2nd page ........................................................
            {
                text: [
                    { text: 'TVARIT ', color: '#FF8C00', bold: true, fontSize: 24 },
                    { text: 'IS POWERING A CUSTOMER', color: 'white', bold: true, fontSize: 24 }
                ],
                alignment: 'center',
                margin: [80, 40, 80, 20]
            },
            {
                text: [
                    { text: 'Revolution to clean, affordable ', color: 'white', bold: true, fontSize: 18 },
                    { text: 'and locally generated ', color: 'white', bold: true, fontSize: 18 },
                    { text: 'energy.', color: 'green', bold: true, fontSize: 18 }
                ],
                alignment: 'center',
                margin: [100, 0, 100, 10]
            },
            {
                stack: [{
                    canvas: [{
                        type: 'rect',
                        x: 120,
                        y: 0,
                        w: 380,
                        h: 190,
                        r: 6,
                        color: '#ffffff',
                        fillOpacity: 1
                    }],
                    absolutePosition: { x: 0, y: 260 }
                },
                {
                    margin: [90, 25, 0, 15],
                    table: {
                        // widths: ['8%', '42%', '20%'],
                        widths: ['10%', '36%', '40%'],
                        body: [
                            [
                                { image: image8, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Customer Name :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.customerName}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image9, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Location :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.location}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image999, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Date :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${formatDate(currentId.Date)}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ],
                            [
                                { image: image10, width: 20, margin: [0, 2, 0, 2] },
                                { text: 'Proposed Capacity :', style: 'label', color: 'black', margin: [0, 2, 0, 0], fontSize: 11 },
                                { text: `${currentId.systemSize}`, bold: true, margin: [0, 2, 0, 0], fontSize: 11 }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: (i, node) => {

                            return (i === 0 || i === node.table.body.length) ? 0 : 0.5;
                        },
                        vLineWidth: () => 0,
                        hLineColor: () => '#ddd',
                        paddingLeft: () => 15,
                        paddingRight: () => 15,
                        paddingTop: () => 8,
                        paddingBottom: () => 8,
                        fillColor: function (rowIndex, node, columnIndex) {
                            return null;
                        }
                    }
                }],
                margin: [0, 50, 0, 80]
            },
            {
                image: image3,
                width: 500,
                alignment: 'center'
            },
            { text: '', pageBreak: 'after' },

            // 3Rd page ........................................................

            {
                columns: [
                    {
                        image: image4,
                        width: 40,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Bill of Material',
                        style: 'header',
                        margin: [20, 12, 0, 0],
                        bold: true,
                        fontSize: 18,
                        color: 'black',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 20]
            },
            {

                table: {
                    headerRows: 1,
                    widths: ['7%', '27%', '28%', '38%'],
                    body: [
                        [
                            { text: 'No.', style: 'tableHeader' },
                            { text: 'Product / Item', style: 'tableHeader' },
                            { text: 'Make', style: 'tableHeader' },
                            { text: 'Technical Specification', style: 'tableHeader' }
                        ],
                        ...(currentId?.SalesDetails || []).map((row, index) => [
                            { text: index + 1, style: 'tableBody' },
                            { text: row.salesproduct || '', style: 'tableBody' },
                            { text: row.salesmake || '', style: 'tableBody' },
                            { text: row.salesspecifiaction || '', style: 'tableBody' }
                        ])
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 2 : 1),
                    vLineWidth: () => 1,
                    vLineColor: () => '#ddd',
                    hLineColor: (i) => (i === 0 ? '#009A47' : '#ddd'),
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: (i) => (i === 0 ? 8 : 6),
                    paddingBottom: (i) => (i === 0 ? 8 : 6),
                }
            },
            {
                image: image5,
                width: 500,
                alignment: 'center',
                margin: [0, 5, 0, 0]
            },
            { text: '', pageBreak: 'after' },


            // 4th page ....................................................
            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 10, 0]
                    },
                    {
                        text: 'Commercial Offer',
                        style: 'header',
                        margin: [20, 0, 0, 2],
                        bold: true,
                        fontSize: 22,
                        color: 'white',
                        alignment: 'left'
                    }
                ],
                margin: [0, 20, 0, 0]
            },
            {
                text: 'Price for Design, Supply, Installation, Testing & Commissioning',
                style: 'subheader',
                margin: [61, 0, 205, 50],
                color: 'white',
                fontSize: 12,
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['7%', '65%', '28%'],
                    body: [
                        [
                            { text: 'No.', style: 'tableHeader', color: 'white' },
                            { text: 'Product / Item', style: 'tableHeader', color: 'white' },
                            { text: 'Amount', style: 'tableHeader', color: 'white' }
                        ],
                        [
                            { text: '1.', style: 'tableBody', alignment: "center" },
                            // { text: `Supply, Installation, Testing & Commissioning of ${currentId.systemSize} kWp Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.`, style: 'tableBody' },
                            {
                                text: [
                                    'Supply, Installation, Testing & Commissioning of ',
                                    { text: `${currentId.systemSize} kWp`, color: '#009A47' },
                                    ' Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.'
                                ],
                                style: 'tableBody'
                            },
                            { text: `Rs. ${currentId.Amount1}/-`, style: 'tableBody', alignment: "center" }
                        ],
                        [
                            { text: '2.', style: 'tableBody', alignment: "center" },
                            { text: `${new Date(currentId.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}`, style: 'tableBody' },
                            { text: ` ${currentId.Amount2}/-`, style: 'tableBody', alignment: "center" }
                        ],
                        [
                            { text: '3.', style: 'tableBody', alignment: "center" },
                            { text: 'Total', style: 'tableBody' },
                            { text: `Rs. ${currentId.Amount3}/-`, style: 'tableBody', alignment: "center" }
                        ],
                    ]
                },
                layout: {
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length ? 2 : 1),
                    vLineWidth: () => 1,
                    vLineColor: () => '#ddd',
                    hLineColor: (i) => (i === 0 ? '#00A651' : '#ddd'),
                    fillColor: (rowIndex) => (rowIndex === 0 ? '#00A651' : '#ffffff'),
                    paddingLeft: () => 4,
                    paddingRight: () => 4,
                    paddingTop: (i) => (i === 0 ? 9 : 12),
                    paddingBottom: (i) => (i === 0 ? 9 : 12),
                }
            },
            {
                text: 'Note:',
                style: 'noteHeader',
                margin: [0, 50, 0, 10]
            },
            {
                ul: currentId?.termsData?.map((term, index) => ({
                    text: [{ text: term.name }, { text: ` :- ${term.description}` }],
                })),
                style: 'noteBody'
            },
            { text: '', pageBreak: 'after' },


            // 5th page ........................................................

            {
                columns: [
                    {
                        image: image4,
                        width: 50,
                        margin: [0, 0, 8, 0]
                    },
                    {
                        text: 'General Terms & Conditions',
                        style: 'header',
                        margin: [30, 10, 0, 10],
                        bold: true,
                        fontSize: 22,
                        color: '#000',
                        alignment: 'left'
                    }
                ],
                margin: [0, 0, 0, 8]
            },

            {
                ul: terms3.map(term => ({
                    stack: [
                        {
                            text: [
                                { text: `${term.title} :- `, bold: true },
                                // { text: '\n' }, // Line break after title
                                { text: term.description } // Description on new line
                            ],
                            margin: [0, 0, 0, 8],
                            fontSize: 9,
                            alignment: 'justify'
                        },
                        {
                            canvas: [
                                {
                                    type: 'line',
                                    x1: 0,
                                    y1: 0,
                                    x2: 515, // Width of the line - adjust as needed
                                    y2: 0,
                                    lineWidth: 1,
                                    lineColor: '#ddd' // Border color - adjust as needed
                                }
                            ],
                            margin: [0, 0, 0, 10] // Margin after border
                        }
                    ]
                })),
                margin: [0, 10, 0, 10],
                style: 'termsList',
                markerColor: '#009A47',
                type: {
                    circle: {
                        width: 50,
                        height: 50,
                        fillColor: '#009A47',
                        borderRadius: 25
                    }
                }
            },

            {
                image: image6,
                width: 500,
                alignment: 'center'
            },
            {
                image: image7,
                width: 500,
                alignment: 'center'
            },


        ],

        styles: {
            header: {
                fontSize: 22,
                bold: true,
                alignment: 'center'

            },
            subheader: {
                fontSize: 16,
                bold: true,
            },
            body: {
                fontSize: 10
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'white',
                fillColor: '#009A47',
                alignment: 'center'
            },
            tableBody: {
                fontSize: 9,
                // alignment: 'center'
            },
            noteHeader: {
                fontSize: 12,
                bold: true,
                color: '#FFA500'
            },
            noteBody: {
                fontSize: 10,
                color: '#FFA500',
            }
        }

    }

    const teal = '#a9c3c9';
    const yellow = '#f3e39c';

    const docDefinition4 = {
        pageMargins: [20, 20, 20, 20],
        defaultStyle: {
            fontSize: 10,
            font: 'Lexend'
        },

        content: [
            {
                table: {
                    widths: ['30%', '70%'],
                    body: [

                        // ===== HEADER ROWS =====
                        [
                            {
                                image: logo,
                                width: 100,
                                rowSpan: 4,
                                margin: [10, 10, 10, 10]
                            },
                            { text: 'Tvarit Energy LLP', bold: true, alignment: 'right', fontSize: 18, fillColor: teal }
                        ],
                        [
                            {},
                            { text: 'Twinstar 7th Floor 707 North Block', alignment: 'right' }
                        ],
                        [
                            {},
                            { text: 'Near Nana Mava Circle 150ft Ring Road Rajkot', alignment: 'right' }
                        ],
                        [
                            {},
                            { text: 'Contact Number - 7405239170', alignment: 'right' }
                        ],

                        // ===== TITLE ROW (FULL WIDTH) =====
                        [
                            {
                                text: 'SOLAR POWER PLANT PROPOSAL : ROOF TOP - CAPTIVE - GRID CONNECTED\nQUOTATION - INDIVIDUAL',
                                colSpan: 2,
                                alignment: 'center',
                                bold: true,
                                margin: [0, 8, 0, 8],
                                border: [true, true, true, false]
                            },
                            {}
                        ]
                    ]
                }
            },

            {
                table: {
                    widths: ['8%', '34%', '18%', '20%', '20%'],
                    body: [

                        // CLIENT INFO
                        [
                            { text: 'Number :', colSpan: 2 }, {},
                            { text: currentId?.QuotationNo || '', colSpan: 2 }, {},
                            { text: `Date : ${currentId?.Date || ''}`, alignment: 'right' }
                        ],

                        [
                            { text: 'Client Name :', colSpan: 2 }, {},
                            { text: currentId?.customerName || '', colSpan: 3 }, {}, {}
                        ],
                        [
                            { text: 'Address :', colSpan: 2 }, {},
                            { text: currentId?.location || '', colSpan: 3 }, {}, {}
                        ],

                        // MAIN TABLE HEADER
                        [
                            { text: 'Sr.no', bold: true, fillColor: teal },
                            { text: 'Description', bold: true, fillColor: teal },
                            { text: 'Capacity (KW)', bold: true, fillColor: teal },
                            { text: 'Rate/KW', bold: true, fillColor: teal },
                            { text: 'Value (INR)', bold: true, fillColor: teal }
                        ],

                        // MAIN ROW
                        [
                            '1',
                            'Design, supply, erection and commissioning of roof top grid tied solar PV power generation plant.',
                            currentId?.systemSize || '',
                            currentId?.systemSize && currentId?.Amount1
                                ? `₹ ${(parseFloat(currentId.Amount1) / parseFloat(currentId.systemSize)).toFixed(2)}`
                                : '',
                            `₹ ${currentId?.Amount1 || ''}`
                        ],

                        [
                            { text: 'Total Value', colSpan: 4, alignment: 'right', bold: true }, {}, {}, {},
                            `₹ ${currentId?.Amount1 || ''}`
                        ],

                        // ITEMS TITLE
                        [
                            { text: 'ITEMS CONSIDERED FOR PROPOSAL', colSpan: 5, alignment: 'center', bold: true },
                            {}, {}, {}, {}
                        ],

                        // ITEMS HEADER
                        [
                            { text: 'Sr.no', bold: true, fillColor: teal },
                            { text: 'Product / Item', bold: true, fillColor: teal },
                            { text: 'Make', bold: true, fillColor: teal },
                            { text: 'Technical Specification', bold: true, fillColor: teal, colSpan: 2 },
                            {}
                        ],

                        // DYNAMIC SALES ROWS
                        ...((currentId?.SalesDetails || []).map((row, index) => ([
                            index + 1,
                            row?.salesproduct || '',
                            row?.salesmake || '',
                            { text: row?.salesspecifiaction || '', colSpan: 2 }, {}
                        ]))),

                        [
                            { text: '', colSpan: 5, margin: [0, 8, 0, 8] },
                            {}, {}, {}, {}
                        ],

                        [
                            { text: '', colSpan: 5, margin: [0, 8, 0, 8], fillColor: teal },
                            {}, {}, {}, {}
                        ],



                        // ================= BANK + CUSTOMER SECTION =================
                        [
                            { text: 'Bank Details:', bold: true, colSpan: 2 }, {},
                            { text: `Customer Name: ${currentId?.customerName || ''}`, colSpan: 3 }, {}, {}
                        ],

                        [
                            { text: 'Account Name: TVARIT ENERGY LLP', colSpan: 2 }, {},
                            { text: 'Signature & Stamp of Company', colSpan: 3, alignment: 'center' }, {}, {}
                        ],

                        [
                            { text: 'Bank: HDFC BANK LTD', colSpan: 2 }, {},
                            { image: stamp, width: 120, rowSpan: 6, colSpan: 3, alignment: 'center', margin: [0, 10, 0, 0] }, {}, {}
                        ],

                        [
                            { text: 'ACC NO: 50200097654228', colSpan: 2 }, {},
                            {}, {}, {}
                        ],

                        [
                            { text: 'IFSC CODE: HDFC0009028', colSpan: 2 }, {},
                            {}, {}, {}
                        ],

                        [
                            { text: 'GST NO: 24AAQFT9592E1ZK', colSpan: 2 }, {},
                            {}, {}, {}
                        ],

                        [
                            { text: 'info@tvaritenergy.in', colSpan: 2 }, {},
                            {}, {}, {}
                        ],

                        [
                            { text: 'Mobile: 7405239170', colSpan: 2 }, {},
                            {}, {}, {}
                        ],

                        [
                            { text: '', colSpan: 5, margin: [0, 8, 0, 8] },
                            {}, {}, {}, {}
                        ],


                        // IMPORTANT REMARKS
                        [
                            { text: 'Important Remarks', colSpan: 5, alignment: 'center', bold: true, fillColor: teal },
                            {}, {}, {}, {}
                        ],

                        [
                            { text: 'Transit insurance belongs to us GST 13.8% Including all tax', colSpan: 5, alignment: 'center', bold: true },
                            {}, {}, {}, {}
                        ],
                        [
                            { text: 'Structure height :- As per Design while installing customer changes the height of structure then structure cost extra as actual', colSpan: 5, alignment: 'center', bold: true },
                            {}, {}, {}, {}
                        ],
                        [
                            { text: 'If customer require invoice of structure then gst extra as actual', colSpan: 5, alignment: 'center', bold: true },
                            {}, {}, {}, {}
                        ],


                        // ...((currentId.termsData || []).map((term) => ([
                        //     { text: `${term.name} - ${term.description}`, colSpan: 5 }, {}, {}, {}, {}
                        // ]))),
                    ]
                }
            }


            // {
            //     table: {
            //         widths: ['8%', '32%', '15%', '15%', '15%', '15%'], // max column structure
            //         body: [

            //             // ================= CLIENT INFO =================
            //             [
            //                 { text: 'Number :', colSpan: 2 }, {},
            //                 { text: currentId?.QuotationNo, colSpan: 2 }, {},
            //                 { text: `Date : ${currentId?.Date}`, colSpan: 2, alignment: 'right' }, {}
            //             ],
            //             [
            //                 { text: 'Client Name :', colSpan: 2 }, {},
            //                 { text: currentId?.customerName, colSpan: 4 }, {}, {}, {}
            //             ],
            //             [
            //                 { text: 'Address :', colSpan: 2 }, {},
            //                 { text: currentId?.location, colSpan: 4 }, {}, {}, {}
            //             ],

            //             // ================= MAIN TABLE HEADER =================
            //             [
            //                 { text: 'Sr.no', fillColor: teal, bold: true },
            //                 { text: 'Description', fillColor: teal, bold: true },
            //                 { text: 'Installed Capacity (KW)', fillColor: teal, bold: true },
            //                 { text: 'Rate/KW', fillColor: teal, bold: true },
            //                 { text: 'Value (INR)', colSpan: 2, fillColor: teal, bold: true }, {}
            //             ],

            //             // ================= MAIN DATA =================
            //             [
            //                 '1',
            //                 'Design, supply, erection and commissioning of roof top grid tied solar PV power generation plant with standard lengths of wires. The solar power plant will consist of required no. of SPV panels, inverter and with all the electrical items suitable to the designed installed capacity.',
            //                 currentId?.systemSize,
            //                 `₹ ${(parseFloat(currentId?.Amount1) / parseFloat(currentId?.systemSize)).toFixed(2)}`,
            //                 { text: `₹ ${currentId?.Amount1}`, colSpan: 2 }, {}
            //             ],

            //             [
            //                 { text: 'Total Value', colSpan: 4, alignment: 'right', fillColor: yellow, bold: true }, {}, {}, {},
            //                 { text: `₹ ${currentId?.Amount1}`, colSpan: 2, fillColor: yellow, bold: true }, {}
            //             ],

            //             // ================= ITEMS TITLE =================
            //             [
            //                 { text: 'ITEMS CONSIDERED FOR PROPOSAL', colSpan: 6, alignment: 'center', bold: true }, {}, {}, {}, {}, {}
            //             ],

            //             // ================= ITEMS HEADER =================
            //             [
            //                 { text: 'Sr.no', fillColor: teal, bold: true },
            //                 { text: 'Product / Item', fillColor: teal, bold: true },
            //                 { text: 'Make', fillColor: teal, bold: true },
            //                 { text: 'Technical Specification.', fillColor: teal, bold: true },
            //             ],
            //             ...(currentId?.SalesDetails?.map((row, index) => ([
            //                 index + 1,
            //                 row.salesproduct || '',
            //                 row.salesmake || '',
            //                 row.salesspecifiaction || '',
            //             ])) || []),
            //             [
            //             '6',
            //             { text: 'GEDA registration, DISCOM and Net meter Charges', colSpan: 4 }, {}, {}, {},
            //             'Included'
            //             ],

            //             // ================= BANK + CUSTOMER =================
            //             [
            //                 { text: 'Bank Details:', colSpan: 3, bold: true }, {}, {},
            //                 { text: `Customer Name: ${currentId?.customerName}`, colSpan: 3 }, {}, {}
            //             ],

            //             [
            //                 { text: 'Account Name: TVARIT ENERGY LLP', colSpan: 3 }, {}, {},
            //                 { text: 'Signature & Stamp of Company', colSpan: 3 }, {}, {}
            //             ],

            //             [
            //                 { text: 'Bank: HDFC BANK LTD', colSpan: 3 }, {}, {},
            //                 { text: '', colSpan: 3 }, {}, {}
            //             ],

            //             [
            //                 { text: 'ACC NO: 50200097654228', colSpan: 3 }, {}, {},
            //                 { text: '', colSpan: 3 }, {}, {}
            //             ],

            //             [
            //                 { text: 'IFSC CODE: HDFC0009028', colSpan: 3 }, {}, {},
            //                 { text: '', colSpan: 3 }, {}, {}
            //             ],

            //             [
            //                 { text: 'GST NO: 24AAQFT9592E1ZK', colSpan: 3 }, {}, {},
            //                 { text: '', colSpan: 3 }, {}, {}
            //             ],

            //             // ================= IMPORTANT REMARKS =================
            //             [
            //                 { text: 'Important Remarks', colSpan: 6, alignment: 'center', bold: true }, {}, {}, {}, {}, {}
            //             ],
            //             [
            //                 { text: 'Transit Insurance belongs to GST 13.8% Including all tax', colSpan: 6 }, {}, {}, {}, {}, {}
            //             ],
            //             [
            //                 { text: 'Structure height - As per Design while installing customer changes the height of structure then structure cost extra as actual', colSpan: 6 }, {}, {}, {}, {}, {}
            //             ],
            //             [
            //                 { text: 'If customer require invoice of structure then gst extra as actual', colSpan: 6 }, {}, {}, {}, {}, {}
            //             ]

            //         ]
            //     },

            // }



            // ================= CLIENT DETAILS =================
            // {
            //     table: {
            //         widths: ['20%', '40%', '15%', '25%'],
            //         body: [
            //             ['Number :', 'QUO/RJT/1743', 'Date :', '15/01/2026'],
            //             ['Client Name :', 'SHISHANGIYA HASIDABEN VASANTBHAI', 'Address :', 'RAJKOT']
            //         ]
            //     },
            //     layout: {
            //         hLineWidth: () => 1,
            //         vLineWidth: () => 1
            //     }
            // },

            // { text: '\n' },

            // // ================= MAIN TABLE =================
            // {
            //     table: {
            //         headerRows: 1,
            //         widths: ['8%', '42%', '15%', '15%', '20%'],
            //         body: [
            //             [
            //                 { text: 'Sr.no', fillColor: teal, bold: true },
            //                 { text: 'Description', fillColor: teal, bold: true },
            //                 { text: 'Installed Capacity (KW)', fillColor: teal, bold: true },
            //                 { text: 'Rate/KW', fillColor: teal, bold: true },
            //                 { text: 'Value (INR)', fillColor: teal, bold: true }
            //             ],
            //             [
            //                 '1',
            //                 'Design, supply, erection and commissioning of roof top grid tied solar PV power generation plant with standard lengths of wires. The solar power plant will consist of required no. of SPV panels, inverter and with all the electrical items suitable to the designed installed capacity.',
            //                 '3.48',
            //                 '₹ 59,253',
            //                 '₹ 206,200'
            //             ],
            //             [
            //                 { text: 'Total Value', colSpan: 4, alignment: 'right', fillColor: yellow, bold: true }, {}, {}, {},
            //                 { text: '₹ 206,200', fillColor: yellow, bold: true }
            //             ]
            //         ]
            //     },
            //     layout: {
            //         hLineWidth: (i, node) =>
            //             (i === 0 || i === node.table.body.length) ? 1.5 : 0.8,
            //         vLineWidth: () => 0.8
            //     }
            // },

            // { text: '\nITEMS CONSIDERED FOR PROPOSAL\n', bold: true, alignment: 'center' },

            // // ================= ITEMS TABLE =================
            // {
            //     table: {
            //         headerRows: 1,
            //         widths: ['8%', '32%', '12%', '12%', '12%', '24%'],
            //         body: [
            //             [
            //                 { text: 'Sr.no', fillColor: teal, bold: true },
            //                 { text: 'Description', fillColor: teal, bold: true },
            //                 { text: 'Unit', fillColor: teal, bold: true },
            //                 { text: 'Qty.', fillColor: teal, bold: true },
            //                 { text: 'Size', fillColor: teal, bold: true },
            //                 { text: 'Make', fillColor: teal, bold: true }
            //             ],
            //             ['1', 'Solar modules', 'Nos', '6', '580', 'WAAREE'],
            //             ['2', 'Module mounting structure', 'Set', 'As per design', '60*40 & 40*40', 'As per Site'],
            //             ['3', 'String type Grid Tied Inverter', 'Nos', 'As per design', '3.6', 'POLYCAB'],
            //             ['4', 'DCDB with accessories', 'Nos', 'As per design', 'As per design', 'Havells/Elmax'],
            //             ['5', 'ACDB', 'Nos', 'As per design', 'As per design', 'Havells/Elmax'],
            //             [
            //                 '6',
            //                 { text: 'GEDA registration, DISCOM and Net meter Charges', colSpan: 4 }, {}, {}, {},
            //                 'Included'
            //             ]
            //         ]
            //     },
            //     layout: {
            //         hLineWidth: () => 0.8,
            //         vLineWidth: () => 0.8
            //     }
            // },

            // { text: '\n' },

            // // ================= BANK + CUSTOMER SECTION =================
            // {
            //     columns: [
            //         {
            //             width: '50%',
            //             table: {
            //                 widths: ['45%', '55%'],
            //                 body: [
            //                     [{ text: 'Bank Details:', colSpan: 2, bold: true }, {}],
            //                     ['Account Name:', 'TVARIT ENERGY LLP'],
            //                     ['Bank:', 'HDFC BANK LTD'],
            //                     ['ACC NO:', '50200097654228'],
            //                     ['IFSC CODE:', 'HDFC0009028'],
            //                     ['GST NO:', '24AAQFT9592E1ZK'],
            //                     ['Email:', 'info@tvaritenergy.in'],
            //                     ['Mobile:', '7405239170']
            //                 ]
            //             }
            //         },
            //         {
            //             width: '50%',
            //             table: {
            //                 widths: ['100%'],
            //                 body: [
            //                     ['Customer Name: SHISHANGIYA HASIDABEN VASANTBHAI'],
            //                     ['Signature & Stamp of Company']
            //                 ]
            //             }
            //         }
            //     ]
            // },

            // { text: '\nImportant Remarks', alignment: 'center', bold: true, margin: [0, 5] },

            // {
            //     table: {
            //         widths: ['100%'],
            //         body: [
            //             ['Transit Insurance belongs to GST 13.8% Including all tax'],
            //             ['Structure height - As per Design while installing customer changes the height of structure then structure cost extra as actual'],
            //             ['If customer require invoice of structure then gst extra as actual']
            //         ]
            //     }
            // }

        ]
    };



    const columns = useMemo(() => [
        {
            field: 'QuotationNo', headerName: 'Quotation No', width: 190,
        },
        {
            field: 'Date',
            headerName: 'Date',
            width: 120,
            valueFormatter: (params) => formatDate(params.value)
        },
        {
            field: 'customerName', headerName: 'Customer Name', width: 250,
        },
        {
            field: 'location', headerName: 'Location', width: 150,
        },
        {
            field: 'systemSize', headerName: 'System Size', width: 100,
        },
        {
            field: 'TypesOfProject', headerName: 'Types Of Project', width: 200,
        },
        {
            field: 'TotalAmount', headerName: 'Total Amount', width: 200,
            renderCell: (params) => {
                return params.row.TypesOfProject === 'Commercial with Large BOM' || params.row.TypesOfProject === 'Commercial with Small BOM' ? params.row.Amount3 : params.row.Amount4
            }
        },
        {
            field: 'userId', headerName: 'User', width: 200,
            renderCell: (params) => {
                return params.row?.userData?.name
            }

        },
        {
            field: 'bomId', headerName: 'Bom', width: 200,
            renderCell: (params) => {
                return params.row.bomId ? (
                    <IconButton aria-label="view" onClick={() => handleOpen(params.row.bomId)}>
                        <RemoveRedEyeIcon />
                    </IconButton>
                ) : 'Bom is Not Availble';
            }
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 160,
            renderCell: (params) => {
                return (
                    <>
                        <IconButton aria-label="view" onClick={() => handleView(params.row)}>
                            <RemoveRedEyeIcon />
                        </IconButton>
                        <IconButton aria-label="print" onClick={() => handlePrint(params.row, params.row.TypesOfProject)}>
                            <PrintIcon />
                        </IconButton>
                        <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                            <EditIcon />
                        </IconButton>
                        <IconButton aria-label="delete" onClick={() => handleDelete(params.row._id)}>
                            <DeleteIcon />
                        </IconButton>
                    </>
                );
            }
        },
    ], [bom]);

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedBomDetails, setSelectedBomDetails] = useState([]);

    const handleView = (details) => {
        setSelectedBomDetails(details);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedBomDetails(null);
    };

    console.log("selectedBomDetails", selectedBomDetails);

    return (
        <Box m="2px">
            <Header
                title="SALES"
                subtitle="Manage Your Sales Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddBOM}>
                    Add Sales
                </Button>
            </Box>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important"
                    },
                }), [colors])}
            >
                <SalesDataGrid data={sortedSales} columns={columns} />
            </Box>


            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Sales?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={handleClose}
                aria-labelledby="bom-dialog-title"
                aria-describedby="bom-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="bom-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                    Print Sales
                </DialogTitle>

                <DialogContent sx={{ paddingX: { xs: '0px', sm: '24px' } }}>
                    {(currentType === "Residential Individual" || currentType === "Residential Comman Meter") && (
                        <Box sx={{ maxWidth: '80%', margin: '0 auto' }}>
                            {/* 1St PAGE ................... */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <img
                                    src="../../assets/images/icons/pdfimage1.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 2nd PAGE ................... */}

                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1B325E', padding: { xs: 1, sm: 3 }, textAlign: 'center' }}>
                                <Typography sx={{ color: '#FF8C00', fontWeight: 'bold', fontSize: { xs: '14px', sm: '36px' }, marginBottom: 1, mx: { xs: 0, sm: 10 }, mt: { xs: 1, sm: 5 } }}>
                                    TVARIT <span style={{ color: 'white' }}>IS POWERING A CUSTOMER</span>
                                </Typography>
                                <Typography sx={{ color: 'white', fontSize: { xs: '14px', sm: '22px' }, marginBottom: 2, mx: { xs: 0, sm: 18 }, fontWeight: '700' }}>
                                    Revolution to clean, affordable and locally generated <span style={{ color: '#00FF00' }}>energy</span>.
                                </Typography>
                                <Box sx={{ backgroundColor: 'white', borderRadius: 2, padding: { xs: '2px', sm: '24px' }, maxWidth: '500px', width: '100%', color: 'black', margin: '0 auto' }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/Home.svg" alt="Building Icon" style={{ marginRight: { xs: 5, sm: 20 } }} />
                                        Customer Name: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.customerName}</strong>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/location.svg" alt="Location Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Location: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.location}</strong>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/calendar.png" alt="Date Icon" style={{ color: '#FF8C00', width: '30px', height: '30px', marginRight: { xs: 0, sm: 20 } }} />
                                        Date: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {formatDate(currentId?.Date)}</strong>
                                    </Typography>
                                    <Typography

                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingBottom: 1,
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/solar.svg" alt="Capacity Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Proposed Capacity: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.systemSize}</strong>
                                    </Typography>

                                </Box>

                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage3.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 3rd PAGE ................... */}

                            <Box sx={{ padding: { xs: '2px', sm: 3 }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2, color: 'black', fontSize: { xs: '14px', sm: '24px' }, display: 'flex', alignItems: 'center', }}>
                                    <img src="../../assets/images/icons/pdfimage4.png" alt="Decorative Icon" style={{ marginRight: { xs: '10px', sm: '20px' } }} />
                                    Bill of Material

                                </Typography>
                                <TableContainer>
                                    <Table sx={{ border: '1px solid #ddd' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#009A47',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>No.</TableCell>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#009A47',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Product / Item</TableCell>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#009A47',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Make</TableCell>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#009A47',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Technical Specification</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {currentId?.SalesDetails?.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{
                                                        color: 'black',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{index + 1}</TableCell>
                                                    <TableCell sx={{
                                                        color: 'black',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{row.salesproduct}</TableCell>
                                                    <TableCell sx={{
                                                        color: 'black',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{row.salesmake}</TableCell>
                                                    <TableCell sx={{
                                                        color: 'black',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{row.salesspecifiaction}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage5.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 4th PAGE ................... */}
                            <Box sx={{
                                backgroundColor: '#1B325E',
                                padding: 3,
                                paddingX: { xs: '0px', sm: '24px' },
                                color: 'white',
                            }}>
                                {/* Header Section */}
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, mt: { xs: '0px', sm: 5 } }}>
                                    <img
                                        src="../../assets/images/icons/pdfimage4.png"
                                        alt="Solar Icon"
                                        style={{ marginRight: "20px" }}

                                    />
                                    <Box>
                                        <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: "10px", fontSize: { xs: '15px', sm: '24px' } }}>
                                            Commercial Offer
                                        </Typography>
                                        <Typography variant="h5" style={{ width: { xs: '100%', sm: '300px' } }} sx={{ fontSize: { xs: '12px', sm: '17px' } }}>
                                            Price for Design, Supply, Installation, Testing & Commissioning
                                        </Typography>
                                    </Box>
                                </Box>


                                {/* Table Section */}
                                <Box sx={{ mt: 5 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: '#009A47' }}>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: { xs: '12px', sm: '14px' } }}>No.</TableCell>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: { xs: '12px', sm: '14px' }, width: { xs: '100%', sm: '70%' } }}>Product / Item</TableCell>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: { xs: '12px', sm: '14px' } }}>Amount</TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>1.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', color: 'black', fontWeight: 600, backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>

                                                        Supply, Installation, Testing & Commissioning of <span style={{ color: '#009A47' }}>{currentId.systemSize} kWp</span> Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.
                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: 600, backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Rs. {currentId.Amount1}/-</TableCell>
                                                </TableRow>
                                                {[
                                                    { no: '2.', item: 'Net Meter, Stamp and MCB Charge', amount: currentId.Amount2, fontSize: { xs: '12px', sm: '14px' } },
                                                    { no: '3.', item: 'Super Structure and Extra Cable Charge', amount: currentId.Amount3, fontSize: { xs: '12px', sm: '14px' } },

                                                    { no: '4.', item: 'Total Amount', amount: currentId.Amount4, fontSize: { xs: '12px', sm: '14px' } },
                                                    { no: '5.', item: 'Government Subsidy Benefit', amount: currentId.Amount5, fontSize: { xs: '12px', sm: '14px' } },

                                                    { no: '6.', item: 'Price After Subsidy', amount: currentId.Amount6, fontSize: { xs: '12px', sm: '14px' } },
                                                ].map((row) => (
                                                    <TableRow key={row.no} sx={{ height: '60px' }}>
                                                        <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: 600, color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>{row.no}</TableCell>
                                                        <TableCell sx={{ border: '1px solid #eee', padding: '20px', fontWeight: 600, color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>{row.item}</TableCell>
                                                        <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: 600, color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Rs. {row.amount}/-</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                    </TableContainer>
                                </Box>
                                {/* Notes Section */}
                                <Box sx={{ mt: 4, pb: 5, mb: 5 }}>
                                    <Typography sx={{ color: '#FFA500', fontWeight: 'bold', mb: 1 }}>Note:</Typography>
                                    <Typography sx={{ color: '#FFA500', fontSize: { xs: '12px', sm: '14px' } }}>
                                        <ul style={{ listStyleType: 'none', padding: 0 }}>

                                            {currentId.termsData.map((term, index) => (
                                                <li key={index}>
                                                    - &nbsp;{term.name} - {term.description}
                                                </li>
                                            ))}
                                        </ul>
                                    </Typography>
                                </Box>
                            </Box>

                            {/* 5th PAGE ................... */}

                            <Box sx={{ p: { xs: '2px', sm: 3 }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#000', display: 'flex', alignItems: 'center', fontSize: { xs: '15px', sm: '24px' } }}>
                                    <span>
                                        <img
                                            src="../../assets/images/icons/pdfimage4.png"
                                            alt="Solar Icon"
                                            style={{ marginRight: { xs: '10px', sm: '30px' } }}

                                        /></span> General Terms & Conditions
                                </Typography>
                                <List className='PDFTEXT'>
                                    {terms.map((term, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                mb: 2,
                                                alignItems: 'flex-start',
                                                borderBottom: '2px solid #eee',
                                                pb: 2,
                                                fontSize: { xs: '12px', sm: '14px' },
                                                textAlign: 'justify'
                                            }}
                                        >
                                            <ListItemIcon>


                                                <CircleIcon sx={{ color: '#00A651', mt: 0.5 }} />
                                            </ListItemIcon>
                                            <div sx={{ display: 'flex' }}>
                                                <span style={{ fontWeight: 'bold', color: '#000', marginRight: '8px' }}>
                                                    {term.title}:
                                                </span>
                                                <span style={{ color: '#000', flex: 1 }}>
                                                    {term.description}
                                                </span>
                                            </div>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage6.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 6th PAGE ................... */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage7.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>
                        </Box>
                    )}

                    {currentType === "Commercial with Large BOM" && (
                        <Box sx={{ maxWidth: '80%', margin: '0 auto' }}>
                            {/* 1St PAGE ................... */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <img
                                    src="../../assets/images/icons/2pdfimg1.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 2nd PAGE ................... */}

                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1B325E', padding: { xs: 1, sm: 3 }, textAlign: 'center' }}>
                                <Typography sx={{ color: '#FF8C00', fontWeight: 'bold', fontSize: { xs: '14px', sm: '36px' }, marginBottom: 1, mx: { xs: 0, sm: 10 }, mt: { xs: 1, sm: 5 } }}>
                                    TVARIT <span style={{ color: 'white' }}>IS POWERING A CUSTOMER</span>
                                </Typography>
                                <Typography sx={{ color: 'white', fontSize: { xs: '14px', sm: '22px' }, marginBottom: 2, mx: { xs: 0, sm: 18 }, fontWeight: '700' }}>
                                    Revolution to clean, affordable and locally generated <span style={{ color: '#00FF00' }}>energy</span>.
                                </Typography>
                                <Box sx={{ backgroundColor: 'white', borderRadius: 2, padding: { xs: '2px', sm: '24px' }, maxWidth: '500px', width: '100%', color: 'black', margin: '0 auto' }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/Home.svg" alt="Building Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Customer Name: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.customerName}</strong>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/location.svg" alt="Location Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Location: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.location}</strong>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/calendar.png" alt="Date Icon" style={{ color: '#FF8C00', width: '30px', height: '30px', marginRight: { xs: 0, sm: 20 } }} />
                                        Date: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {formatDate(currentId?.Date)}</strong>
                                    </Typography>
                                    <Typography

                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingBottom: 1,
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/solar.svg" alt="Capacity Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Proposed Capacity: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.systemSize}</strong>
                                    </Typography>
                                </Box>

                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage3.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 3rd PAGE ................... */}

                            <Box sx={{ padding: { xs: '10px', sm: '30px' }, backgroundColor: '#FFFBF0' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 5, mb: 4 }}>
                                    <img
                                        src="../../assets/images/icons/pdfimage4.png"
                                        alt="Solar Icon"
                                        style={{ marginRight: { xs: "5px", sm: "20px" } }}
                                    />
                                    <Box sx={{ color: '#000' }}>
                                        <Typography variant="h3" sx={{ fontWeight: 'bold', fontSize: { xs: '14px', sm: '24px' } }}>
                                            Confidentiality &
                                        </Typography>
                                        <Typography variant="h3" sx={{ fontWeight: 'bold', fontSize: { xs: '14px', sm: '24px' } }}>

                                            General Conditions Notice
                                        </Typography>
                                    </Box>
                                </Box>
                                <Typography variant="body1" sx={{ color: '#000', fontWeight: 600, mb: 2, textAlign: 'justify', fontSize: { xs: '13px', sm: '14px' } }}>
                                    This commercial proposal for installation of solar rooftop power system (the "proposal") is submitted with the intent of executing a definitive and legally binding agreement (the "agreement") following an award of business to tvarit energy llp. ("tvarit").
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#000', fontWeight: 600, mb: 2, textAlign: 'justify', fontSize: { xs: '13px', sm: '14px' } }}>
                                    The Proposal itself is a legally binding offer to contract and in the event of an award to Tvarit Energy, it shall execute an Agreement that will be the complete agreement between the parties, however, where the parties do not execute any such Agreement, then the terms and conditions mentioned in this Proposal shall govern any purchase order(s) issued by the Customer in reference to the installation of rooftop solar power system.
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#000', fontWeight: 600, mb: 2, textAlign: 'justify', fontSize: { xs: '13px', sm: '14px' } }}>

                                    This Proposal constitutes confidential and proprietary information of Tvarit and requires that customer treat the information contained in this proposal as confidential. Customer may use the information contained in this proposal solely for the purposes of evaluating this proposal & executing the agreement with Tvarit. This proposal & all supporting documentation and manuals provided to customer in connection with this proposal shall remain the property of Tvarit & must be returned immediately upon request.
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#000', fontWeight: 600, mb: 2, textAlign: 'justify', fontSize: { xs: '13px', sm: '14px' } }}>
                                    This proposal is based upon the set of requirements provided by customer to Tvarit, and certain reasonable assumptions taken by Tvarit and that may be set forth by owner. If customer alters the requirements or if any assumption stated here in are false or inaccurate, then this proposal, including pricing, may change. Implementation of any services detailed in this proposal is subject to applicable legal and regulatory norms and requirements in force as on the date when services are to be implemented and such implementation may vary to cater to the requirements of such applicable legal and regulatory norms and requirements.
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 4 }}>
                                    <img
                                        src="../../assets/images/icons/2pdfimg2.jpg"
                                        alt="Decorative"
                                        style={{ width: '100%', height: 'auto' }}
                                    />
                                </Box>
                            </Box>


                            {/* 4th PAGE ................... */}

                            <Box sx={{ p: { xs: '0px', sm: '24px' }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#000', display: 'flex', alignItems: 'center', fontSize: { xs: '15px', sm: '24px' } }}>
                                    <span>
                                        <img
                                            src="../../assets/images/icons/pdfimage4.png"
                                            alt="Solar Icon"
                                            style={{ marginRight: { xs: "7px", sm: "20px" } }}
                                        /></span> Scope Of Work
                                </Typography>

                                <Typography variant="h4" sx={{ color: '#000', mb: 2, fontWeight: 'bold', ml: 2, fontSize: { xs: '14px', sm: '24px' } }}>
                                    Our Scope
                                </Typography>
                                <List>
                                    {terms1.map((term, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                mb: { xs: '0px', sm: '2px' },
                                                alignItems: 'flex-start',
                                                borderBottom: '2px solid #eee',
                                                pb: { xs: '0px', sm: '2px' },
                                                paddingX: { xs: '2px', sm: '16px' }
                                            }}
                                        >
                                            <ListItemIcon>
                                                <CircleIcon sx={{ color: '#00A651', mt: 0.5 }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={<Typography sx={{ color: '#000', fontWeight: 600, fontSize: { xs: '12px', sm: '14px' } }}>{term.title}</Typography>}
                                                secondary={<Typography sx={{ color: '#000', textWrap: "nowrap" }}>{term.description}</Typography>}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage6.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>


                            {/* 5th PAGE ................... */}

                            <Box sx={{ p: { xs: '0px', sm: '24px' }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#000', display: 'flex', alignItems: 'center', fontSize: { xs: '15px', sm: '24px' } }}>
                                    <span>
                                        <img

                                            src="../../assets/images/icons/pdfimage4.png"
                                            alt="Solar Icon"
                                            style={{ marginRight: { xs: '8px', sm: '20px' } }}

                                        />
                                    </span>
                                    Scope Of Work
                                </Typography>

                                <Typography variant="h4" sx={{ color: '#000', mb: 2, fontWeight: 'bold', ml: 2, fontSize: { xs: '14px', sm: '24px' } }}>
                                    Customer's Scope
                                </Typography>
                                <List>
                                    {terms2.map((term, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                mb: { xs: '0px', sm: '2px' },
                                                alignItems: 'flex-start',
                                                borderBottom: '2px solid #eee',
                                                pb: { xs: '0px', sm: '2px' },
                                                paddingX: { xs: '2px', sm: '16px' }
                                            }}
                                        >
                                            <ListItemIcon>

                                                <CircleIcon sx={{ color: '#00A651', mt: 0.5 }} />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={<Typography sx={{ color: '#000', fontWeight: 600, fontSize: { xs: '12px', sm: '14px' } }}>{term.title}</Typography>}
                                                secondary={<Typography sx={{ color: '#000' }}>{term.description}</Typography>}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage6.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>



                            {/* 6th PAGE ................... */}
                            <Box sx={{ p: { xs: '0px', sm: '24px' }, backgroundColor: '#FFFBF0', }}>
                                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#000', display: 'flex', alignItems: 'center', fontSize: { xs: '15px', sm: '24px' } }}>
                                    <span>
                                        <img
                                            src="../../assets/images/icons/pdfimage4.png"
                                            alt="Solar Icon"
                                            style={{ marginRight: '20px' }}
                                        />
                                    </span>
                                    Bill of Material
                                </Typography>
                                <TableContainer >
                                    <Table >
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#00A651' }}>
                                                <TableCell sx={{
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>No.</TableCell>

                                                <TableCell sx={{
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Product / Item</TableCell>


                                                <TableCell sx={{
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Make</TableCell>


                                                <TableCell sx={{
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Technical Specification</TableCell>
                                            </TableRow>
                                        </TableHead>


                                        <TableBody>
                                            {currentId?.SalesDetails?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{
                                                        border: '1px solid #eee',
                                                        textAlign: 'center',
                                                        color: '#000000',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600

                                                    }}>{index + 1}</TableCell>
                                                    <TableCell sx={{
                                                        border: '1px solid #eee',
                                                        textAlign: 'center',
                                                        color: '#000000',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600
                                                    }}>{item.salesproduct}</TableCell>
                                                    <TableCell sx={{
                                                        border: '1px solid #eee',
                                                        textAlign: 'center',
                                                        color: '#000000',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600
                                                    }}>{item.salesmake}</TableCell>
                                                    <TableCell sx={{
                                                        border: '1px solid #eee',
                                                        textAlign: 'center',
                                                        color: '#000000',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600
                                                    }}>{item.salesspecifiaction}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>

                            {/* 7th PAGE ................... */}

                            <Box sx={{
                                backgroundColor: '#1B325E',
                                padding: 3,
                                paddingX: { xs: '0px', sm: '24px' },
                                color: 'white',
                            }}>
                                {/* Header Section */}
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, mt: { xs: '0px', sm: 5 } }}>
                                    <img
                                        src="../../assets/images/icons/pdfimage4.png"
                                        alt="Solar Icon"
                                        style={{ marginRight: "20px" }}

                                    />
                                    <Box>
                                        <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: "10px", fontSize: { xs: '15px', sm: '24px' } }}>
                                            Commercial Offer
                                        </Typography>
                                        <Typography variant="h5" style={{ width: { xs: '100%', sm: '300px' } }} sx={{ fontSize: { xs: '12px', sm: '17px' } }}>
                                            Price for Design, Supply, Installation, Testing & Commissioning
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Table Section */}
                                <Box sx={{ mt: 5 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: '#009944' }}>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>No.</TableCell>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px', width: '70%' }}>Product / Item</TableCell>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: '14px' }}>Amount</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>1.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>
                                                        Supply, Installation, Testing & Commissioning of <span style={{ color: '#009944' }}>{currentId.systemSize} kWp</span> Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.

                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Rs. {currentId.Amount1}/-</TableCell>
                                                </TableRow>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>2.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>{new Date(currentId.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}</TableCell>

                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>{currentId.Amount2}/-</TableCell>
                                                </TableRow>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>3.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Total</TableCell>

                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', fontWeight: '600', color: '#000', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Rs. {currentId.Amount3}/-</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>

                                {/* Notes Section */}
                                <Box sx={{ mt: 4, pb: 5, mb: 5 }}>
                                    <Typography sx={{ color: '#FFA500', fontWeight: 'bold', mb: 1 }}>Note:</Typography>
                                    <Typography sx={{ color: '#FFA500', fontSize: { xs: '12px', sm: '14px' } }}>
                                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                                            {currentId.termsData.map((term, index) => (
                                                <li key={index}>
                                                    - &nbsp;{term.name} - {term.description}
                                                </li>
                                            ))}
                                        </ul>
                                    </Typography>
                                </Box>
                            </Box>

                            {/* 8th PAGE ................... */}
                            <Box sx={{ p: { xs: '0px', sm: '24px' }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#000', display: 'flex', alignItems: 'center', fontSize: { xs: '15px', sm: '24px' } }}>
                                    <span>
                                        <img

                                            src="../../assets/images/icons/pdfimage4.png"
                                            alt="Solar Icon"
                                            style={{ marginRight: '20px' }}
                                        />
                                    </span>
                                    General Terms & Conditions
                                </Typography>
                                <List className='PDFTEXT' sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                                    {[
                                        {
                                            title: "PRICE:",
                                            description: "The price quoted in this Proposal is inclusive of design, manufacturing, sourcing, testing, installation, supply & commissioning, as per the bill of materials & ratings submitted by Tvarit along with the final offer. Any change in scope of work or addition to the bill of materials and / or ratings or any variation, whatsoever, shall be charged extra to Customer."
                                        },
                                        {
                                            title: "THE PRICE QUOTED IS CIF-SITE AND IS FIRM:",
                                            description: "The price is exclusive of any taxes, annual maintenance charges or comprehensive maintenance charges or operation & maintenance charges. Any statutory variation in taxes and duties from the date of submission of this proposal including change of rates for Solar PV System and / or its parts / components / equipment's under GST, imposition of Antidumping Duty (ADD) and / or Safeguard Duty (SDD) on imported modules and cells by the Government of India would be to the clients account and shall be payable by the client at actuals."
                                        },
                                        {
                                            title: "PAYMENT TERMS:",
                                            description: "The payment terms applicable are as follows: A. 20% of Advance amount of total contract value to be paid by Customer along with the Purchase Order B. 40% of total contract value to be paid by customer after getting approvals from nodal agency. C. 30% of total contract value to be paid by customer along with the readiness of material before dispatch. D. 10% of the total contract value within 7 days of installation and commissioning of the plant."
                                        },
                                        {
                                            title: "VALIDITY OF OFFER:",
                                            description: "He price quoted by Tvarit along with this Proposal is valid for 15 days and thereafter the same shall be subject to reconfirmation by Tvarit."
                                        },
                                        {
                                            title: "TAXES, DUTIES AND RATES:",
                                            description: "Tvarit at its sole discretion shall have the liberty to raise invoices from any location in India. All the applicable taxes shall be payable by the Customer at actual. Any Variation in taxes & duties as per the statutory requirements or Government notifications will be applicable at the time of supply. Any other taxes / Octroi applicable will be extra to be paid by the customer."
                                        },
                                        {
                                            title: "INCLUSION OF / EXCLUDED ITEMS:",
                                            description: "Any items not mentioned in the bill of material shall be charged extra and will be to customer's account."
                                        },
                                        {
                                            title: "ACCESS AND PERMITS:",
                                            description: "The Customer shall ensure the accuracy of all information and / or data to be supplied by the Customerand shall be responsible foracquiring and providing legal andphysical possession of the Site and access thereto, for preparation and maintenance of proper access roads to, and provide the right of way for, the site, and for providing possession of and access to all other areas reasonably required for the proper execution of the contract work, including all requisite rights of way. Customer shall ensure handing over valid road permits (multiple numbers depending on number of truck loads) Tvarit at least five (5) working days prior to dispatch of any supplies."
                                        },
                                        {
                                            title: "INTERRUPTIONS IN WORK:",
                                            description: "The Customer must not interrupt the works, and/or shall abstain from any act or Comission of which it canreasonably be expected that it may delay the works or make the works more difficult and or expensive for Tvarit Energy."
                                        }
                                    ].map((term, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                mb: 2,
                                                alignItems: 'flex-start',
                                                borderBottom: '2px solid #eee',
                                                pb: 2,
                                                textAlign: 'justify'
                                            }}
                                        >
                                            <ListItemIcon>

                                                <CircleIcon sx={{ color: '#00A651', mt: 0.5 }} />
                                            </ListItemIcon>
                                            <div sx={{ display: 'flex' }}>
                                                <span style={{ fontWeight: 'bold', color: '#000', marginRight: '8px' }}>
                                                    {term.title}
                                                </span>
                                                <span style={{ color: '#000', flex: 1 }}>
                                                    {term.description}
                                                </span>
                                            </div>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>

                            {/* 9th PAGE ................... */}
                            <Box sx={{ p: { xs: '0px', sm: '24px' }, backgroundColor: '#FFFBF0' }}>
                                <List className='PDFTEXT' sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                                    {[

                                        {
                                            title: "DEEMED EXPORT OF POWER:",
                                            description: "The Project shall be termed as commissioned when Tvarit evacuates the power generated to Customer grid. However, incase where Tvarit has completed its duties as per the scope of duties mentioned in the Purchase Order, and the Project cannot be commissioned due to any act / inaction on the part of Customer, or due to unavailability of Customer grid, then the Project shall be deemed to be commissioned and Tvarit shall be deemed to have completed its part of obligations under the Purchase Order."
                                        },
                                        {
                                            title: "WARRANTY:",
                                            description: "The solar power plant carries a FIVE (5) years' warranty against any manufacturing defects, as per existing warranty policy Tvarit Energy. Solar photovoltaic modules carry a performance warranty against excess of 20% degradation in TWENTY-FIVE (25) years as per existing warranty policy of Tvarit Energy. Tempering, Misuse, addition, dismantling, reinstallation of any of the system components by unauthorized personnel will render warranty null and void."
                                        },
                                        {
                                            title: "SECURITY & SAFETY:",
                                            description: "On delivery of supplies to Customer's site in good condition, Customer shall be responsible for safety & security of the materials till handing over of the same to Tvarit designated personnel for installation. In case there are public disturbances at site which are not exclusively attributable to Tvarit, Customer shall resolve the same at its own risk & cost, for smooth execution of the project by Tvarit. In such case, Customer shall provide safety & security for the Tvarit designated personnel working at site. Any delay in execution or damage of materials due to public disturbances at site shall be attributable to & compensated by Customer."
                                        },
                                        {
                                            title: "CIVIL & STRUCTURAL WORK:",
                                            description: "Tvarit limits itself to providing structures for its module mounting on RCC roofs and raised structures (raised structures will be provided by Customer). Any changes in design which are attributable to Customer shall be charged extra. Customer shall allow roof penetration for Installation of module mounting clamps on Trapezoidal Sheet profile. The customer shall allow scrapping of the roof for binding civil foundation, hole fastening the structure on the roof or bolting on the shade roofs. However necessary water proofing treatment shall be taken care during the installation. Any additional ground leveling or earthfilling if required as per the site conditions shall be charged extra."
                                        },
                                        {
                                            title: "PERMISSIONS & NOCS:",
                                            description: "Necessary permissions from various Government authorities and departments for power evacuation shall be taken by the Tvarit. All the applications shall be done in customers name and necessary charges, fees and other expenses shall be paid by the customer which is included in quotation. However, we shall support for submission of plant related details & documents as required for filing applications. Bi-Directional and Energy Meter cost is extra."
                                        },
                                        {
                                            title: "OPERATION & MAINTENANCE (O&M):",
                                            description: "O&M charges and spares are not included in this offer. However, Tvarit is open to provide AMC Services in a separate contract."
                                        },
                                        {
                                            title: "GOVERNING LAW & JURISDICTION:",
                                            description: "All questions concerning the construction, validity and interpretation of this Proposal or any resultant Agreement will be governed by the laws of India, and the courts at Rajkot, India shall have exclusive jurisdiction with respect to any dispute that occurs hereof. No remedy described in this Proposal or any resultant Agreement shall in any way limit the parties' remedies available at law, in equity or otherwise in relation to any breach or threatened breach of the terms and condition of the Proposal by any defaulting party, and any party may seek a restrictive injunction from an appropriate court of law to safeguard its interests."
                                        }
                                    ].map((term, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                mb: 2,
                                                alignItems: 'flex-start',
                                                borderBottom: '2px solid #eee',
                                                pb: 2,
                                                textAlign: 'justify'
                                            }}
                                        >
                                            <ListItemIcon>

                                                <CircleIcon sx={{ color: '#00A651', mt: 0.5 }} />
                                            </ListItemIcon>
                                            <div sx={{ display: 'flex' }}>
                                                <span style={{ fontWeight: 'bold', color: '#000', marginRight: '8px' }}>
                                                    {term.title}
                                                </span>
                                                <span style={{ color: '#000', flex: 1 }}>
                                                    {term.description}
                                                </span>
                                            </div>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>

                            {/* 10th PAGE ................... */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <img
                                    src="../../assets/images/icons/pdfimage7.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>
                        </Box>
                    )}

                    {currentType === "Commercial with Small BOM" && (
                        <Box sx={{ maxWidth: '80%', margin: '0 auto' }}>
                            {/* 1St PAGE ................... */}

                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <img
                                    src="../../assets/images/icons/3pdfimg11.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 2nd PAGE ................... */}


                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1B325E', padding: { xs: 1, sm: 3 }, textAlign: 'center' }}>
                                <Typography sx={{ color: '#FF8C00', fontWeight: 'bold', fontSize: { xs: '14px', sm: '36px' }, marginBottom: 1, mx: { xs: 0, sm: 10 }, mt: { xs: 1, sm: 5 } }}>
                                    TVARIT <span style={{ color: 'white' }}>IS POWERING A CUSTOMER</span>
                                </Typography>
                                <Typography sx={{ color: 'white', fontSize: { xs: '14px', sm: '22px' }, marginBottom: 2, mx: { xs: 0, sm: 18 }, fontWeight: '700' }}>
                                    Revolution to clean, affordable and locally generated <span style={{ color: '#00FF00' }}>energy</span>.
                                </Typography>
                                <Box sx={{ backgroundColor: 'white', borderRadius: 2, padding: { xs: '2px', sm: '24px' }, maxWidth: '500px', width: '100%', color: 'black', margin: '0 auto' }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/Home.svg" alt="Building Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Customer Name: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.customerName}</strong>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/location.svg" alt="Location Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Location: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.location}</strong>
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: 2,
                                            paddingBottom: 2,
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/calendar.png" alt="Date Icon" style={{ color: '#FF8C00', width: '30px', height: '30px', marginRight: { xs: 0, sm: 20 } }} />
                                        Date: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {formatDate(currentId?.Date)}</strong>
                                    </Typography>
                                    <Typography

                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingBottom: 1,
                                            fontSize: { xs: '10px', sm: '16px' }
                                        }}
                                    >
                                        <img src="../../assets/images/icons/solar.svg" alt="Capacity Icon" style={{ marginRight: { xs: 0, sm: 20 } }} />
                                        Proposed Capacity: &nbsp; <strong sx={{ fontSize: { xs: '12px', sm: '16px' } }}> {currentId.systemSize}</strong>
                                    </Typography>
                                </Box>

                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage3.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>


                            {/* 3rd PAGE ................... */}

                            <Box sx={{ padding: { xs: 1, sm: 3 }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2, color: 'black', fontSize: { xs: '14px', sm: '24px' }, display: 'flex', alignItems: 'center', }}>
                                    <img src="../../assets/images/icons/pdfimage4.png" alt="Decorative Icon" style={{ marginRight: 8, }} />
                                    Bill of Material
                                </Typography>
                                <TableContainer>
                                    <Table sx={{ border: '1px solid #ddd' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#00A651',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>No.</TableCell>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#00A651',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Product / Item</TableCell>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#00A651',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Make</TableCell>
                                                <TableCell sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#00A651',
                                                    color: 'white',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '15px' }
                                                }}>Technical Specification</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {currentId?.SalesDetails?.map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{
                                                        color: '#1a1a1a',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{index + 1}</TableCell>
                                                    <TableCell sx={{
                                                        color: '#1a1a1a',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{row.salesproduct}</TableCell>
                                                    <TableCell sx={{
                                                        color: '#1a1a1a',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{row.salesmake}</TableCell>
                                                    <TableCell sx={{
                                                        color: '#1a1a1a',
                                                        border: '1px solid #ddd',
                                                        fontSize: { xs: '12px', sm: '14px' },
                                                        fontWeight: 600,
                                                        padding: '12px 16px'
                                                    }}>{row.salesspecifiaction}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: '0px', sm: '100px' } }}>
                                <img
                                    src="../../assets/images/icons/pdfimage5.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>

                            {/* 4th PAGE ................... */}
                            <Box sx={{
                                backgroundColor: '#1B325E',
                                padding: 3,
                                paddingX: { xs: '0px', sm: '24px' },
                                color: 'white',
                            }}>
                                {/* Header Section */}
                                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2, mt: { xs: '0px', sm: 5 } }}>
                                    <img
                                        src="../../assets/images/icons/pdfimage4.png"
                                        alt="Solar Icon"
                                        style={{ marginRight: "20px" }}

                                    />
                                    <Box>
                                        <Typography variant="h3" sx={{ fontWeight: 'bold', marginBottom: "10px", fontSize: { xs: '15px', sm: '24px' } }}>
                                            Commercial Offer
                                        </Typography>
                                        <Typography variant="h5" style={{ width: { xs: '100%', sm: '300px' } }} sx={{ fontSize: { xs: '12px', sm: '17px' } }}>
                                            Price for Design, Supply, Installation, Testing & Commissioning
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Table Section */}
                                <Box sx={{ mt: 5 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow sx={{ backgroundColor: '#00A651' }}>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: { xs: '12px', sm: '14px' } }}>No.</TableCell>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: { xs: '12px', sm: '14px' }, width: { xs: '100%', sm: '70%' } }}>Product / Item</TableCell>
                                                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '10px', fontSize: { xs: '12px', sm: '14px' } }}>Amount</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>1.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>

                                                        Supply, Installation, Testing & Commissioning of <span style={{ color: '#00A651' }}>{currentId.systemSize} kWp</span> Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.
                                                    </TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Rs. {currentId.Amount1}/-</TableCell>
                                                </TableRow>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>2.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>{new Date(currentId.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>{currentId.Amount2}/-</TableCell>

                                                </TableRow>
                                                <TableRow sx={{ height: '60px' }}>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>3.</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Total</TableCell>
                                                    <TableCell sx={{ border: '1px solid #eee', textAlign: 'center', padding: '20px', color: '#000', fontWeight: '600', backgroundColor: 'white', fontSize: { xs: '12px', sm: '14px' } }}>Rs. {currentId.Amount3}/-</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>

                                {/* Notes Section */}
                                <Box sx={{ mt: 4, pb: 5, mb: 5 }}>
                                    <Typography sx={{ color: '#FFA500', fontWeight: 'bold', mb: 1 }}>Note:</Typography>
                                    <Typography sx={{ color: '#FFA500', fontSize: { xs: '12px', sm: '14px' } }}>
                                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                                            {currentId.termsData.map((term, index) => (
                                                <li key={index}>
                                                    - &nbsp;{term.name} - {term.description}
                                                </li>
                                            ))}
                                        </ul>
                                    </Typography>
                                </Box>
                            </Box>

                            {/* 5th PAGE ................... */}

                            <Box sx={{ p: { xs: '0px', sm: '24px' }, backgroundColor: '#FFFBF0' }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#000', display: 'flex', alignItems: 'center', fontSize: { xs: '15px', sm: '24px' } }}>
                                    <img
                                        src="../../assets/images/icons/pdfimage4.png"
                                        alt="Solar Icon"
                                        style={{ marginRight: '8px' }}
                                    />
                                    General Terms & Conditions
                                </Typography>
                                <List className='PDFTEXT' sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                                    {[
                                        {
                                            title: "PRICE:",
                                            description: "The price quoted in this Proposal is inclusive of design, manufacturing, sourcing, testing, installation, supply & commissioning, as per the bill of materials & ratings submitted by Tvarit along with the final offer."
                                        },
                                        {
                                            title: "PAYMENT TERMS:",
                                            description: "100% of Advance amount of total contract value to be paid by Customer along with the Purchase Order"
                                        },
                                        {
                                            title: "VALIDITY OF OFFER:",
                                            description: "The price quoted by Tvarit along with this Proposal is valid for 30 days and thereafter the same shall be subject to reconfirmation by Tvarit."
                                        },
                                        {
                                            title: "SCOPE OF WORK:",
                                            description: "Any change in scope of work or addition to the bill of materials and / or ratings or any variation, whatsoever, shall be charged extra to Customer"
                                        },
                                        {
                                            title: "WARRANTY:",
                                            description: "The solar power plant carries a FIVE (5) years' warranty against any manufacturing defects, as per existing warranty policy Tvarit Energy. Solar photovoltaic modules carry a performance warranty against excess of 20% degradation in TWENTY-FIVE (25) years as per existing warranty policy of Tvarit Energy. Solar Grid Tie Inverter carry a DC Side 7 Year performance warranty. Tempering, Misuse, addition, dismantling, reinstallation of any of the system components by unauthorized personnel will render warranty null and void."
                                        },
                                        {
                                            title: "TAXES, DUTIES AND RATES:",
                                            description: "Any Variation in taxes & duties as per the statutory requirements or Government notifications will be applicable at the time of supply. Any other taxes / Octroi applicable will be extra to be paid by the customer."
                                        },
                                        {
                                            title: "OPERATION & MAINTENANCE (O&M):",
                                            description: "Technical Guidance and only Service charges are included in this offer Upto 5 year"
                                        },
                                        {
                                            title: "GOVERNING LAW & JURISDICTION:",
                                            description: "All questions concerning the construction, validity and interpretation of this Proposal or any resultant Agreement will be governed by the laws of India, and the courts at Rajkot, India shall have exclusive jurisdiction with respect to any dispute that occurs hereof."
                                        }
                                    ].map((term, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                mb: 2,
                                                alignItems: 'flex-start',
                                                borderBottom: '2px solid #eee',
                                                pb: 2,
                                                textAlign: 'justify'

                                            }}
                                        >
                                            <ListItemIcon>
                                                <CircleIcon sx={{ color: '#00A651', mt: 0.5 }} />
                                            </ListItemIcon>
                                            <div sx={{ display: 'flex' }}>
                                                <span style={{ fontWeight: 'bold', color: '#000', marginRight: '8px' }}>
                                                    {term.title}
                                                </span>
                                                <span style={{ color: '#000', flex: 1 }}>
                                                    {term.description}
                                                </span>
                                            </div>
                                        </ListItem>
                                    ))}
                                </List>
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: { xs: "0px", sm: "100px" } }}>
                                    <img
                                        src="../../assets/images/icons/pdfimage6.jpg"
                                        alt="Tvarit Energy LLP"
                                        style={{ width: '100%', height: 'auto' }}
                                    />
                                </Box>
                            </Box>

                            {/* 6th PAGE ................... */}
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <img
                                    src="../../assets/images/icons/pdfimage7.jpg"
                                    alt="Tvarit Energy LLP"
                                    style={{ width: '100%', height: 'auto' }}
                                />
                            </Box>
                        </Box>
                    )}

                    {currentType === "Individual" && (
                        <Paper sx={{ p: 3, maxWidth: 1000, margin: "auto", border: "1px solid #000" }}>

                            {/* Header Section */}
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography variant="h4" fontWeight="bold">
                                        <img
                                            src="../../assets/images/logo/light-logo.png"
                                            alt="Tvarit Energy LLP"
                                            style={{ width: '200px', height: 'auto' }}
                                        />
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} textAlign="right">
                                    <Typography fontWeight="bold">Tvarit Energy LLP</Typography>
                                    <Typography variant="body1">
                                        Twinstar 7th Floor 707 North Block <br />
                                        Near Nana Mauva Circle 150ft Ring Road Rajkot <br />
                                        Contact Number - 7405239170
                                    </Typography>
                                    <Typography variant="body1">
                                        B/1, First Floor, Shree Nath Complex,
                                        Zanzarda Road, Junagadh, Gujarat - 362001
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 2 }} />

                            {/* Title */}
                            <Typography align="center" fontWeight="bold">
                                SOLAR POWER PLANT PROPOSAL : ROOF TOP - CAPTIVE - GRID CONNECTED
                            </Typography>
                            <Typography align="center" fontWeight="bold">
                                QUOTATION - INDIVIDUAL
                            </Typography>

                            <Divider sx={{ my: 2 }} />

                            {/* Client Info */}
                            <Grid container spacing={2}>
                                <Grid item xs={8}>
                                    <Typography><strong>Number:</strong> {currentId?.QuotationNo}</Typography>
                                    <Typography><strong>Client Name:</strong> {currentId?.customerName}</Typography>
                                    <Typography><strong>Address:</strong> {currentId?.location}</Typography>
                                </Grid>

                                <Grid item xs={4} textAlign="right">
                                    <Typography><strong>Date:</strong> {currentId?.Date}</Typography>
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 2 }} />

                            {/* Main Proposal Table */}
                            <TableContainer>
                                <Table sx={{ border: '1px solid #ddd' }}>
                                    <TableHead sx={{ backgroundColor: "#b2ebf2" }}>
                                        <TableRow>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}><strong>Sr.no</strong></TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}><strong>Description</strong></TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}><strong>Installed Capacity (KW)</strong></TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}><strong>Rate/KW</strong></TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}><strong>Value (INR)</strong></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        <TableRow>
                                            <TableCell>1</TableCell>
                                            <TableCell>
                                                Design, supply, erection and commissioning of roof top grid tied solar PV
                                                power generation plant with standard lengths of wires. The solar power
                                                plant will consist of required no. of SPV panels, inverter and with all
                                                the electrical items suitable to the designed installed capacity.
                                            </TableCell>
                                            <TableCell>{currentId?.systemSize}</TableCell>
                                            <TableCell>₹ {(parseFloat(currentId?.Amount1) / parseFloat(currentId?.systemSize)).toFixed(2)}</TableCell>
                                            <TableCell>₹ {currentId?.Amount1}</TableCell>
                                        </TableRow>

                                        <TableRow sx={{ backgroundColor: "#fff59d" }}>
                                            <TableCell colSpan={4} align="right">
                                                <strong>Total Value</strong>
                                            </TableCell>
                                            <TableCell>
                                                <strong>₹ {currentId?.Amount1}</strong>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Divider sx={{ my: 3 }} />

                            {/* Items Considered Table */}
                            <Typography fontWeight="bold" align="center" gutterBottom>
                                ITEMS CONSIDERED FOR PROPOSAL
                            </Typography>

                            <TableContainer>
                                <Table sx={{ border: '1px solid #ddd' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}>No.</TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}>Product / Item</TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}>Make</TableCell>
                                            <TableCell sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#009A47',
                                                color: 'white',
                                                border: '1px solid #ddd',
                                                fontSize: { xs: '12px', sm: '15px' }
                                            }}>Technical Specification</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {currentId?.SalesDetails?.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{
                                                    color: 'black',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '14px' },
                                                    fontWeight: 600,
                                                    padding: '12px 16px'
                                                }}>{index + 1}</TableCell>
                                                <TableCell sx={{
                                                    color: 'black',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '14px' },
                                                    fontWeight: 600,
                                                    padding: '12px 16px'
                                                }}>{row.salesproduct}</TableCell>
                                                <TableCell sx={{
                                                    color: 'black',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '14px' },
                                                    fontWeight: 600,
                                                    padding: '12px 16px'
                                                }}>{row.salesmake}</TableCell>
                                                <TableCell sx={{
                                                    color: 'black',
                                                    border: '1px solid #ddd',
                                                    fontSize: { xs: '12px', sm: '14px' },
                                                    fontWeight: 600,
                                                    padding: '12px 16px'
                                                }}>{row.salesspecifiaction}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Divider sx={{ my: 3 }} />

                            {/* Bank Details */}
                            <Typography fontWeight="bold" gutterBottom>
                                Bank Details:
                            </Typography>

                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Typography>Account Name: TVARIT ENERGY LLP</Typography>
                                    <Typography>Bank: HDFC Bank Ltd</Typography>
                                    <Typography>ACC No: 50200097654228</Typography>
                                    <Typography>IFSC Code: HDFC0009028</Typography>
                                    <Typography>GST No: 24AAQFT9592E1ZK</Typography>
                                    <Typography>Email: info@tvaritenergy.in</Typography>
                                    <Typography>Mobile: 7405239170</Typography>
                                </Grid>

                                <Grid item xs={6} textAlign="center">
                                    <Box sx={{ mt: 6 }}>
                                        <Typography>Signature & Stamp of Company</Typography>
                                        <img src="../../assets/images/stamp/stamp.svg" alt="Building Icon" style={{ marginRight: { xs: 0, sm: 20 }, width: '150px' }} />
                                    </Box>
                                </Grid>
                            </Grid>

                            <Divider sx={{ my: 3 }} />

                            {/* Remarks */}
                            <Box sx={{ mt: 4, pb: 5, mb: 5 }}>
                                <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Important Remarks:</Typography>
                                <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        {/* {currentId.termsData.map((term, index) => (
                                            <li key={index}>
                                                - &nbsp;{term.name} - {term.description}
                                            </li>
                                        ))} */}
                                        <li>Transit insurance belongs to us GST 13.8% Including all tax</li>
                                        <li>Structure height :- As per Design while installing customer changes the height of structure then structure cost extra as actual</li>
                                        <li>If customer require invoice of structure then gst extra as actual</li>
                                    </ul>
                                </Typography>
                            </Box>

                        </Paper>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                    <Button
                        onClick={() => {
                            if (currentType === "Residential Individual" || currentType === "Residential Comman Meter") {
                                pdfMake.createPdf(docDefinition).download(fileName + '.pdf');
                            } else if (currentType === "Commercial with Large BOM") {
                                pdfMake.createPdf(docDefinition2).download(fileName + '.pdf');
                            } else if (currentType === "Individual") {
                                pdfMake.createPdf(docDefinition4).download(fileName + '.pdf');
                            } else {
                                pdfMake.createPdf(docDefinition3).download(fileName + '.pdf');
                            }
                        }}
                        sx={{ color: theme.palette.text.primary }}
                    >
                        Download PDF
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="bom-dialog-title"
                aria-describedby="bom-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="bom-dialog-title" sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                    Bill of Materials Details
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="bom-dialog-description">
                        {selectedSalesDetails && (
                            <>
                                <div style={{ display: 'flex', color: theme.palette.text.primary }}>
                                    <ul style={{ listStyle: 'none', padding: 0 }}>
                                        <li>Name</li>
                                        <li>System Size </li>
                                        <li>Date </li>
                                        <li>Types Of Project </li>
                                    </ul>
                                    <ul style={{ listStyle: 'none' }}>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedSalesDetails?.BOMName}</li>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedSalesDetails?.systemSize}</li>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{formatDate(selectedSalesDetails?.Date)}</li>
                                        <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedSalesDetails?.TypesOfProject}</li>
                                    </ul>
                                </div>

                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Category</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Sub Category</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Product</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Description</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Quantity</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Price</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedSalesDetails?.BomDetails?.map((bom, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {categories?.find(category => category._id === bom?.bomcategory)?.categoryName || bom?.bomcategory}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {subcategories?.find(subcategory => subcategory._id === bom?.bomsubcategory)?.subCategoryName || bom?.bomsubcategory}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {productData?.find(product => product._id === bom?.bomproduct)?.productName || bom?.bomproduct}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomdescription}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomqty}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomlastprice}
                                                </TableCell>
                                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                                    {bom?.bomamount}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        }
                                    </TableBody>
                                </Table>

                                <Table sx={{ mt: 2 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}></TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Remarks</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>System Size</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Unit Price</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Dealer Commission in KW</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Remarks1}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.SystemSize1}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.unitprice1}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Amount1}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Interest</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Remarks2}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.SystemSize2}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.unitprice2}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Amount2}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Service & Maintenance</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Remarks3}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.SystemSize3}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.unitprice3}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Amount3}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Profit in KW</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Remarks4}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.systemSize}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.unitprice4}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Amount4}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Net Meter, Stamp and MCB Charge</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Remarks5}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.SystemSize5}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.unitprice5}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Amount5}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Super Structure and Extra Cabel Charge</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Remarks6}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.SystemSize6}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.unitprice6}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Amount6}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>

                                <Table sx={{ mt: 2 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>GST</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>TotalAmount</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Subcidy</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Price After Subcidy	</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.Total}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.GST}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.TotalAmount}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.subcidy}</TableCell>
                                            <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedSalesDetails?.PriceAfterSubcidy}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </>
                        )}

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: theme.palette.text.primary }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth={"sm"}
                fullWidth>
                <DialogTitle textAlign={'center'} fontWeight={700}>Sales Details</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', color: theme.palette.text.primary }}>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            <li>Quotation No</li>
                            <li>Customer Name</li>
                            <li>System Size </li>
                            <li>Date </li>
                            <li>Location </li>
                            <li>Types Of Project </li>
                        </ul>
                        <ul style={{ listStyle: 'none' }}>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.QuotationNo}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.customerName}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.systemSize}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{formatDate(selectedBomDetails?.Date)}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.location}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.TypesOfProject}</li>
                        </ul>
                    </div>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '150px' }}>Product</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '150px' }}>Make</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '150px' }}>Specifiaction</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedBomDetails?.SalesDetails?.map((bom, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.salesproduct}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.salesmake}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.salesspecifiaction}
                                    </TableCell>
                                </TableRow>
                            ))
                            }
                        </TableBody>
                    </Table>

                    <Table sx={{ mt: 2 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '0px' }}>No.	</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '300px' }}>Product / Item</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '10px' }}>Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedBomDetails?.TypesOfProject === "Residential Individual" ||
                                selectedBomDetails?.TypesOfProject === "Residential Comman Meter" ? (
                                <>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>1.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Supply, Installation, Testing & Commissioning of {selectedBomDetails?.systemSize} kWp Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount1}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>2.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Net Meter, Stamp and MCB Charge</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount2}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>3.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Super Structure and Extra Cable Charge</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount3}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>4.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total Amount</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount4}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>5.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Government Subsidy Benefit</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount5}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>6.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Price After Subsidy</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount6}/-</TableCell>
                                    </TableRow>
                                </>
                            ) : selectedBomDetails?.TypesOfProject === "Commercial with Large BOM" ? (
                                <>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>1.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Supply, Installation, Testing & Commissioning of {selectedBomDetails?.systemSize} kWp Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount1}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>2.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{new Date(selectedBomDetails?.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount2}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>3.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total Amount</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount3}/-</TableCell>
                                    </TableRow>
                                </>
                            ) : selectedBomDetails?.TypesOfProject === "Commercial with Small BOM" ? (
                                <>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>1.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Supply, Installation, Testing & Commissioning of {selectedBomDetails?.systemSize} kWp Grid Tied Solar Power Plant with Solar Panels, Solar Inverter, Module Mounting Structure & BOS.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount1}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>2.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{new Date(selectedBomDetails?.Date) <= new Date("2025-09-21") ? 'GST (13.8%)' : 'GST (8.9%)'}</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount2}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>3.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total Amount </TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount3}/-</TableCell>
                                    </TableRow>
                                </>
                            ) : selectedBomDetails?.TypesOfProject === "Individual" ? (
                                <>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>1.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Design,supply,erection and commissioning of roof top grid tied solar PV power generation plant with standard lengths of wires. The solar power plant will consist of required no. of SPV panels, inverter and with all the electrical items suitable to the designed installed capacity.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>₹ {selectedBomDetails?.Amount1}/-</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>2.</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Rate/KW</TableCell>
                                        <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{(selectedBomDetails?.Amount1 / selectedBomDetails.systemSize).toFixed(2)}/-</TableCell>
                                    </TableRow>

                                </>) : null}
                        </TableBody>

                    </Table>

                    <Grid container sx={{ mt: 2 }}>
                        <Grid item xs={6}>
                            <Typography variant="body1" sx={{ marginBottom: '10px', fontWeight: '700' }}>
                                {
                                    selectedBomDetails?.TypesOfProject !== "Individual" ? 'Terms and Conditions:' : 'Important Remarks'
                                }
                                
                                </Typography>
                            <Grid container>
                                {selectedBomDetails?.termsData && selectedBomDetails.termsData.length > 0 ? (
                                    selectedBomDetails?.TypesOfProject !== "Individual" ? selectedBomDetails.termsData.map((term, index) => (
                                        <Grid item xs={12} key={index} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <Grid container>
                                                <Grid item xs={1}>
                                                    <Typography variant="body2">
                                                        <span style={{ fontSize: '20px', lineHeight: '0' }}>•</span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography variant="body2" sx={{
                                                        fontWeight: '600',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word'
                                                    }}>
                                                        {(term)?.name || 'N/A'}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Typography variant="body2" sx={{
                                                        fontWeight: '600',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word'
                                                    }}> :
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Typography variant="body2" sx={{
                                                        fontWeight: '600',
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        whiteSpace: 'pre-line'
                                                    }}>
                                                        {(term)?.description || ''}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )) : <ul>
                                        <li>Transit insurance belongs to us GST 13.8% Including all tax</li>
                                        <li>Structure height :- As per Design while installing customer changes the height of structure then structure cost extra as actual</li>
                                        <li>If customer require invoice of structure then gst extra as actual</li>
                                    </ul>
                                ) : (
                                    <Grid item xs={12}>
                                        <Typography variant="body2" sx={{ fontWeight: '600' }}><strong>-</strong></Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>

        </Box >
    )
}

export default Sales
